<template>
  <div id="checkinDetail" class="Content-Page">
    <div id="namePage" class="wrap-Main">
      <div class="box-S4">
        <div class="N-Page T-size-36">
          Check-in Flight
          <v-btn
            class="theme-btn-even"
            :to="{
              name: 'FlightDetail',
              params: { mode: 'Edit', id: idflight },
            }"
            ><span class="T-size-10">Flight No. {{ idflight }}</span>
          </v-btn>
        </div>
      </div>
    </div>
    <div
      id="flightDetail"
      class="wrap-Main"
      v-if="userdata.r_id == 5 || userdata.r_id == 21"
    >
      <div class="box-S2">
        <div class="box-S4">
          <div class="B-carddetail B-formMain">
            <div class="b-row">
              <div class="box-S2">
                <v-text-field
                  label="Ref No."
                  v-model="ref_id"
                  disabled
                ></v-text-field>
              </div>
              <div class="box-S2">
                <v-text-field
                  label="Flight No."
                  v-model="flightno"
                  disabled
                ></v-text-field>
              </div>
            </div>
            <div class="b-row">
              <div class="box-S2">
                <v-select
                  class="hideMessage"
                  :items="itemsListCustomer"
                  item-text="o_name"
                  item-value="o_id"
                  label="Customer"
                  v-model="customer"
                  return-object
                  disabled
                ></v-select>
              </div>
              <div class="box-S2">
                <v-select
                  class="hideMessage"
                  :items="itemsListFlightType"
                  label="Type Of Flight"
                  v-model="flighttype"
                  return-object
                  disabled
                ></v-select>
              </div>
            </div>
            <div class="b-row">
              <div class="box-S2">
                <v-select
                  class="hideMessage"
                  :items="itemsListTerminal"
                  item-text="tm_name"
                  item-value="tm_id"
                  label="Terminal"
                  v-model="terminal"
                  return-object
                  :disabled="
                    readonly_eng ||
                    readonly_pilot ||
                    readonly_shore ||
                    readonly_finance ||
                    readonly_flight ||
                    readonly_checkin ||
                    readonly_super_flight
                  "
                ></v-select>
              </div>
              <div class="box-S2">
                <v-select
                  class="hideMessage"
                  :items="itemsListCheckInVideo"
                  item-text="v_name"
                  item-value="v_id"
                  label="Brief Check in Video"
                  v-model="videoCheckin"
                  return-object
                  :disabled="
                    readonly_eng ||
                    readonly_pilot ||
                    readonly_shore ||
                    readonly_finance ||
                    readonly_flight ||
                    readonly_checkin ||
                    readonly_super_flight
                  "
                ></v-select>
              </div>
            </div>
            <div class="b-row">
              <div class="box-S4">
                <v-select
                  class="hideMessage"
                  :items="itemsListFlightStatus"
                  item-text="fs_name"
                  item-value="fs_id"
                  label="Flight Status"
                  v-model="flightstatus"
                  return-object
                  :disabled="
                    readonly_eng ||
                    readonly_pilot ||
                    readonly_shore ||
                    readonly_finance ||
                    readonly_flight ||
                    readonly_checkin ||
                    readonly_super_flight
                  "
                ></v-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-S2">
        <div class="box-S4">
          <div class="B-carddetail B-formMain">
            <div class="b-row">
              <div class="box-S4">
                <v-combobox
                  :items="itemsListPilot"
                  label="Pilot"
                  v-model="pilot"
                  disabled
                ></v-combobox>
              </div>
            </div>
            <div class="b-row">
              <div class="box-S4">
                <v-combobox
                  class="hideMessage"
                  :items="itemsListPilot"
                  label="Co-Pilot"
                  v-model="copilot"
                  disabled
                ></v-combobox>
              </div>
            </div>
            <div class="b-row">
              <div class="box-S4">
                <v-select
                  class="hideMessage"
                  :items="itemsListAircraft"
                  item-text="ac_name"
                  item-value="ac_id"
                  label="Aircraft"
                  v-model="aircraft"
                  return-object
                  disabled
                ></v-select>
              </div>
            </div>
            <div class="b-row">
              <div class="box-S4">
                <v-text-field
                  label="Assign By"
                  v-model="aircraftAssignBy"
                  disabled
                ></v-text-field>
                <v-text-field
                  label="Assign Time"
                  :value="aircraftAssignTime | yyyyMMddHHmm"
                  disabled
                ></v-text-field>
              </div>
            </div>
            <!-- <div class="b-row">
              <v-btn @click="ReviseAircraftAndDepartureTime()">
                <span class="T-size-18"
                  >Revise Aircraft And Departure Time</span>
              </v-btn>
            </div> -->
          </div>
        </div>
      </div>
      <div class="line"></div>
    </div>

    <div
      id="destinationLeg"
      class="wrap-Main"
      v-if="userdata.r_id == 5 || userdata.r_id == 21"
    >
      <div class="box-S4">
        <div class="N-Page T-size-24">Destination Leg</div>
      </div>
      <div class="box-S4">
        <div class="warp-destiantionShow">
          <div class="box-S1">
            <!-- Leg เริ่มต้น -->
            <div class="b-destiantionShow start">
              <div class="B-carddetail">
                <div class="b-content">
                  <i class="I-departure"></i>
                  <div class="t-name T-size-20 SemiBold">
                    {{ depart_airport }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="box-S1" v-for="item in 6" :key="item"> -->
          <div class="box-S1" v-for="item in ArrlistAddLegs" :key="item.ap_id">
            <!-- Loop ชุดนี้ -->
            <div class="b-destiantionShow">
              <div class="B-carddetail">
                <div class="b-content">
                  <div class="t-name T-size-20 SemiBold">
                    {{ item.ap_name }}
                  </div>
                  <div class="tag" v-show="item.activity1 != null">
                    {{ item.activity1 }}
                  </div>
                  <div class="tag" v-show="item.activity2 != null">
                    {{ item.activity2 }}
                  </div>
                  <div class="tag" v-show="item.activity3 != null">
                    {{ item.activity3 }}
                  </div>
                  <div class="tag" v-show="item.activity4 != null">
                    {{ item.activity4 }}
                  </div>
                  <div class="numderPassenger">
                    <div class="t-up T-size-24">
                      <span>{{ item.l_ob | setzoro }}</span>
                      <i class="I-down"></i>
                    </div>
                    <div class="t-down T-size-24">
                      <i class="I-up"></i>
                      <span>{{ item.l_ib | setzoro }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-S1">
            <!-- Leg จบ -->
            <div class="b-destiantionShow end">
              <div class="B-carddetail">
                <div class="b-content">
                  <i class="I-arrival"></i>
                  <div class="t-name T-size-20 SemiBold">
                    {{ dest_airport }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <!-- <div id="payload" class="wrap-Main">
      <div class="box-S4">
        <div class="N-Page T-size-24">Payload</div>
      </div>
      <div class="box-S1">
        <div class="B-carddetail">
          <div class="b-detail">
            <div class="b-icon">
              <span class="icon I-bodyweight"></span>
            </div>
            <div class="b-text">
              <p>Body Weight</p>
              <p class="T-size-20 SemiBold">xxx Kg.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="box-S1">
        <div class="B-carddetail">
          <div class="b-detail">
            <div class="b-icon">
              <span class="icon I-baggageweight"></span>
            </div>
            <div class="b-text">
              <p>Baggage Weight</p>
              <p class="T-size-20 SemiBold">xxx Kg.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="box-S1">
        <div class="B-carddetail">
          <div class="b-detail">
            <div class="b-icon">
              <span class="icon I-cargo"></span>
            </div>
            <div class="b-text">
              <p>Cargo Weight</p>
              <p class="T-size-20 SemiBold">xxx Kg.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="box-S1">
        <div class="B-carddetail">
          <div class="b-detail">
            <div class="b-icon">
              <span class="icon I-totalweight"></span>
            </div>
            <div class="b-text">
              <p>Total Weight</p>
              <p class="T-size-20 SemiBold">xxx Kg.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="line"></div>
    </div>-->
    <div
      id="payload"
      class="wrap-Main"
      v-if="userdata.r_id == 5 || userdata.r_id == 21"
    >
      <div class="box-S4">
        <div class="N-Page T-size-24">Payload</div>
      </div>
      <div class="box-S1">
        <div class="B-carddetail">
          <div class="b-detail">
            <div class="b-icon">
              <span class="icon I-bodyweight"></span>
            </div>
            <div class="b-text">
              <p>Body Weight</p>
              <p class="T-size-20 SemiBold">
                {{ sumbodyweight.toFixed(2) }} Kg.
              </p>
              <!-- <p class="T-size-20 SemiBold"  v-if="mode == 'Create'">0.00 Kg.</p>
              <p class="T-size-20 SemiBold" v-else>{{itemsCalWeightFlight.body_weight[0].toFixed(2)}} Kg.</p>-->
            </div>
          </div>
        </div>
      </div>
      <div class="box-S1">
        <div class="B-carddetail">
          <div class="b-detail">
            <div class="b-icon">
              <span class="icon I-baggageweight"></span>
            </div>
            <div class="b-text">
              <p>Baggage Weight</p>
              <p class="T-size-20 SemiBold">
                {{ sumbaggageweight.toFixed(2) }} Kg.
                <span style="font-size: 16px; font-weight: 300"
                  >( {{ CountfromOutboundPassengerBaggage }} )</span
                >
              </p>
              <!-- <p class="T-size-20 SemiBold"  v-if="mode == 'Create'">0.00 Kg.</p>
              <p class="T-size-20 SemiBold" v-else>{{itemsCalWeightFlight.baggage_weight[0].toFixed(2)}} Kg.</p>-->
            </div>
          </div>
        </div>
      </div>
      <div class="box-S1">
        <div class="B-carddetail">
          <div class="b-detail">
            <div class="b-icon">
              <span class="icon I-cargo"></span>
            </div>
            <div class="b-text">
              <p>Cargo Weight</p>
              <!-- <p class="T-size-20 SemiBold"  v-if="mode == 'Create'">0.00 Kg.</p>
              <p class="T-size-20 SemiBold" v-else>{{itemsCalWeightFlight.cargo_weight[0].toFixed(2)}} Kg.</p>-->

              <p class="T-size-20 SemiBold">{{ sumcargo.toFixed(2) }} Kg.
                <span style="font-size: 16px; font-weight: 300"
                  >( {{ totalCargo_amount }} )</span
                >
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="box-S1">
        <div class="B-carddetail">
          <div class="b-detail">
            <div class="b-icon">
              <span class="icon I-totalweight"></span>
            </div>
            <div class="b-text">
              <p>Total Weight</p>
              <p class="T-size-20 SemiBold">{{ sumTotal.toFixed(2) }} Kg.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="box-S4" v-if="sumcargo + sumbaggageweight > 300">
        <div class="B-carddetail" style="background-color: crimson">
          <div class="b-detail">
            Warning Baggage Weight + Cargo Weight More than 300 Kg
          </div>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <!-- <div id="outPassenger" class="wrap-Main">
      <div class="box-S4 flex-between-center">
        <div class="N-Page T-size-24">Outbound Passengers</div>
        <div class="b-numPassenger">
          <span class="icon I-passengers"></span>
          <div class="T-size-20 SemiBold">8 Passengers</div>
        </div>
      </div>
      <div class="box-S4">
        <v-expansion-panels accordion class="b-accod">
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="panal-title T-size-20">Passenger List</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="wrap-passenger">
                <div class="box-S1-3" v-for="item in 6" :key="item">
                  <div class="B-passenger">
                    <div>
                      <div class="b-person">
                        <div class="b-display">
                          <div class="B-display person1"></div>
                       
                        </div>
                        <div class="b-name-company">
                          <p class="t-name T-size-14">{PEERAPONG SAE-LAO</p>
                          <div class="t-company T-size-12">Company : CPOC</div>
                        </div>
                      </div>
                      <div class="b-detail">
                        <div class="t-title">Destiantion</div>
                        <div class="box-S4 flex-between-center t-detail">
                          <div class="bL">
                            <span class="T-size-12">Departure From</span>
                            <p class="T-size-16">VTSH</p>
                          </div>
                          <div class="bC">
                            <span class="T-size-12">Inter Field</span>
                            <i class="I-check"></i>
                          </div>
                          <div class="bR">
                            <span class="T-size-12">Destination</span>
                            <p class="T-size-16">AQD</p>
                          </div>
                        </div>
                      </div>
                      <div class="b-detail">
                        <div class="t-title">Personal Data</div>
                        <div class="box-S4 flex-between-center t-detail">
                          <div class="bL">
                            <span class="T-size-12">Body Weight</span>
                            <p class="T-size-16">999 Kg.</p>
                          </div>
                          <div class="bC">
                            <span class="T-size-12">Alcohol</span>
                            <i class="I-check3"></i>
                          </div>
                          <div class="bR">
                            <span class="T-size-12">Baggage Weight</span>
                            <p class="T-size-16">999 Kg.</p>
                          </div>
                        </div>
                      </div>
                      <div class="b-btnCheckin">
                        <v-btn class="theme-btn-even btn-checkin" href="#/personalcheckin">
                          <span class="T-size-18">Check-in</span>
                        </v-btn>
                        <v-btn class="theme-btn-even" href="#/personalcheckin">
                          <span class="T-size-18">View</span>
                        </v-btn>
                      </div>
                    </div>
                    <div class="b-offload">
                      <span class="t-text T-size-24">Off Load</span>
                      <v-btn class="theme-btn-even btn-recover">
                        <span class="T-size-18">Recover</span>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <div class="box-S1-3">
        <v-btn class="theme-btn-even MGB10">
          <span class="I-create"></span>
          <span>Add</span>
        </v-btn>
      </div>
      <div class="line"></div>
    </div>-->

    <CompAddPassengerOutbound2
      ref="CompAddPassengerOutbound2"
      @SumDataLegInAndOut="DataLegsFromDB"
      @SumDataBodyWeightOutbound="BodyOut"
      @SumDataBaggageWeightOutbound="BaggageOut"
      @CountDataBaggageWeightOutbound="CountBaggageOut"
      :flightId="$route.params.id"
    ></CompAddPassengerOutbound2>

    <div
      id="Cargo"
      class="wrap-Main"
      v-if="userdata.r_id == 5 || userdata.r_id == 21"
    >
      <div class="box-S4 flex-between-center">
        <div class="N-Page T-size-24">Customer Belonging Manifest</div>
        <v-btn
          class="theme-btn-even"
          @click="addItemCargo()"
          v-if="userdata.r_id == 5"
        >
          <span class="I-create"></span>
          <span>Add cargo</span>
        </v-btn>
      </div>
      <div class="box-S4">
        <div class="wrap-cargo">
          <div
            class="box-S1-3"
            v-for="(item, index) in listAddCargo"
            :key="item.Idflightcargo"
          >
            <div class="B-passenger cargo">
              <!-- เพิ่ม Class update / delete เมื่อมีการส่งค่าว่าโดนแก้ไข หรือ ลบ -->
              <div>
                <div class="b-person">
                  <div class="b-name-company">
                    <p class="t-name T-size-14">Item Name</p>
                  </div>
                  <div class="b-action">
                    <div class="b-btn">
                      <v-btn
                        v-if="userdata.r_id == 5"
                        fab
                        class="btn-edit"
                        @click="EditItemCargo(item, index)"
                      >
                        <span class="I-edit"></span>
                      </v-btn>
                      <v-btn
                        v-if="userdata.r_id == 5"
                        fab
                        class="primary btn-delete"
                        @click="deleteItemCargo(item)"
                      >
                        <span class="I-bin"></span>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div class="b-detail">
                  <div class="box-S4 flex-between-center t-detail">
                    <div class="bL">
                      <span class="T-size-12">DAN No.</span>
                      <p class="T-size-16">{{ item.cg_dan_no }}</p>
                    </div>
                    <div class="bL">
                      <span class="T-size-12">Weight</span>
                      <p class="T-size-16">{{ item.cg_weight }}</p>
                    </div>
                    <div class="bR">
                      <span class="T-size-12">Destination</span>
                      <p class="T-size-16">{{ item.Destinations.ap_name }}</p>
                    </div>
                  </div>
                </div>
                <div class="b-detail">
                  <div class="box-S4 flex-between-center t-detail">
                    <div class="bL">
                      <span class="T-size-12">Consigned to</span>
                      <p class="T-size-16">{{ item.cg_contact }}</p>
                    </div>
                  </div>
                </div>
                <div class="b-detail">
                  <div class="t-title">Cargo Details</div>
                  <div class="box-S4 t-detail">
                    <p class="T-size-16 detail">{{ item.cg_remark }}</p>
                  </div>
                </div>
              </div>
              <div class="b-recover">
                <v-btn class="theme-btn-even btn-recover">
                  <span class="T-size-18">Recover</span>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line"></div>
    </div>

    <div
      id="checkinReport"
      class="wrap-Main"
      v-if="userdata.r_id == 5 || userdata.r_id == 21"
    >
      <div class="box-S1-3">
        <div class="box-S4">
          <div class="N-Page T-size-24">Manifest</div>
        </div>
        <div class="box-S4">
          <div class="B-carddetail">
            <v-btn
              class="theme-btn-even btn-report center Bsize190"
              @click="Manifest_Report()"
            >
              <span class="I-report"></span>
              <span class="T-size-18">Manifest</span>
            </v-btn>
          </div>
        </div>
      </div>
      <div class="box-S1-3">
        <div class="box-S4">
          <div class="N-Page T-size-24">BAC Report</div>
        </div>
        <div class="box-S4">
          <div class="B-carddetail">
            <v-btn
              class="theme-btn-even btn-report center Bsize190"
              @click="BAC_Report()"
            >
              <span class="I-report"></span>
              <span class="T-size-18">BAC Report</span>
            </v-btn>
          </div>
        </div>
      </div>
      <div class="box-S1-3">
        <div class="box-S4">
          <div class="N-Page T-size-24">Seat Layout</div>
        </div>
        <div class="box-S4">
          <div class="B-carddetail">
            <v-btn
              class="theme-btn-even btn-report center Bsize190"
              :to="{
                name: 'SeatLayout',
                params: { mode: 'CheckinDetail', idflight: idflight },
              }"
              style="padding-top: 6.5px"
            >
              <span class="I-report"></span>
              <span class="T-size-18">Seat Layout</span>
            </v-btn>
          </div>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div
      id="partSave"
      class="wrap-Main"
      v-if="userdata.r_id == 5 || userdata.r_id == 21"
    >
      <div class="box-S4">
        <div class="b-btnSave" v-if="userdata.r_id == 5">
          <v-btn class="theme-btn-even btn-cancle Bsize150" @click="Back()">
            <span class="T-size-18">Cancel</span>
          </v-btn>
          <v-btn
            class="theme-btn-even btn-save Bsize150"
            @click="dialogSave = true"
          >
            <span class="I-save"></span>
            <span class="T-size-18">Save</span>
          </v-btn>
        </div>
        <!-- <div class="b-btnDelete">
          <v-switch
            @change="RealtimeMonitor()"
            v-model="realtimeMonitor"
            :label="`Real-Time Monitor`"
          ></v-switch>
        </div> -->
      </div>

      <div class="box-S4">
        <div class="b-btnSave">
          <v-btn
            v-show="true"
            class="theme-btn-even btn-report center"
            text
            :disabled="!(flightstatus.fs_id == 4)"
            @click="FlightClosed()"
          >
            <span class="T-size-18">Flight Closed And Send Notification</span>
          </v-btn>
        </div>
      </div>
      <div class="line"></div>
    </div>

    <div id="partBack" class="wrap-Main">
      <div class="box-S4">
        <v-btn text class="ColorTheme-S white--text theme-btn" @click="Back()">
          <span class="I-back"></span>
          <span>Back</span>
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="dialogSave" persistent max-width="300">
      <v-card id="dialog" class="TF type1">
        <div class="b-content">
          <div class="B-dialog save">
            <div class="t-title">Confirm Save</div>
            <div class="t-des">Are you sure you want to save this item?</div>
          </div>
          <div class="box-btn">
            <v-btn
              class="theme-btn-even btn-cancel Bsize100"
              text
              @click="dialogSave = false"
              :disabled="buttonCancel"
            >
              <span class="T-size-18">cancel</span>
            </v-btn>
            <v-btn
              class="theme-btn-even btn-save Bsize100"
              text
              @click="SaveEditToDB()"
              :disabled="buttonSave"
            >
              <span class="T-size-18">Save</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <!-- Add -->
    <v-dialog v-model="dialogConfirm" persistent max-width="300">
      <v-card id="dialog" class="TF type1">
        <div class="b-content">
          <div class="B-dialog confirm">
            <div class="t-title">Save Completed</div>
          </div>
          <div class="box-btn">
            <v-btn
              class="theme-btn-even btn-ok Bsize100"
              text
              @click="SaveCompleted()"
            >
              <span class="T-size-18">OK</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCargo" persistent max-width="400">
      <v-card id="dialog" class="TF type3">
        <div class="b-content">
          <div class="B-dialogform">
            <div class="t-namepage">Add Cargo</div>
            <div class="b-form">
              <v-text-field
                class="hideMessage"
                v-model="cg_dan_no"
                label="DAN No."
              ></v-text-field>
              <v-text-field
                class="hideMessage"
                v-model="cg_weight"
                label="Weight"
                suffix="Kg."
              ></v-text-field>
              <v-text-field
                class="hideMessage"
                v-model="cg_amount"
                label="Amount"
                suffix=""
              ></v-text-field>
              <v-select
                class="hideMessage"
                :items="itemsListAirport"
                item-text="ap_name"
                item-value="ap_id"
                label="Destination"
                v-model="Destinations"
                return-object
              ></v-select>

              <v-text-field
                class="hideMessage"
                v-model="cg_contact"
                label="Consigned to"
              ></v-text-field>
            </div>
            <div class="t-namepage2">Cargo Details</div>
            <div class="b-form">
              <v-text-field
                class="hideMessage"
                v-model="cg_remark"
                label="Details"
              ></v-text-field>
            </div>
          </div>
          <div class="box-btn">
            <v-btn
              class="theme-btn-even btn-cancel Bsize100"
              text
              @click="dialogCargo = false"
            >
              <span class="T-size-18">cancel</span>
            </v-btn>
            <v-btn
              class="theme-btn-even btn-save Bsize100"
              text
              @click="SaveCargo()"
            >
              <span class="T-size-18">save</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogReviseAircraftAndDepartTime"
      persistent
      max-width="400"
    >
      <v-card id="dialog" class="TF type3">
        <div class="b-content">
          <div class="B-dialogform">
            <div class="t-namepage">
              Manage Revise AirCraft And Departure Time
            </div>
            <div class="b-form">
              <div class="b-row">
                <div class="box-S4">
                  <v-select
                    class="hideMessage"
                    :items="itemsListAircraft"
                    item-text="ac_name"
                    item-value="ac_id"
                    label="Aircrafts"
                    v-model="revise_aircraft"
                    return-object
                  ></v-select>
                </div>
              </div>
              <div class="b-row">
                <div class="box-S4">
                  <v-menu
                    :disabled="
                      readonly_eng ||
                      readonly_pilot ||
                      readonly_shore ||
                      readonly_finance
                    "
                    v-model="menuselect_depart_date_revise"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        class="hideMessage input-date"
                        v-model="depart_date_revise"
                        label="Departure Date"
                        readonly
                        v-on="on"
                        append-icon="mdi-calendar-range"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="depart_date"
                      :readonly="
                        readonly_eng ||
                        readonly_pilot ||
                        readonly_shore ||
                        readonly_finance
                      "
                      @input="menuselect_depart_date_revise = false"
                    ></v-date-picker>
                  </v-menu>
                </div>

                <div class="box-S4">
                  <v-text-field
                    label="Departure Time"
                    :readonly="
                      readonly_eng ||
                      readonly_pilot ||
                      readonly_shore ||
                      readonly_finance
                    "
                    v-model="depart_time_revise"
                    type="time"
                  ></v-text-field>
                </div>
              </div>
            </div>
          </div>
          <div class="box-btn">
            <v-btn
              class="theme-btn-even btn-cancel Bsize100"
              text
              @click="dialogReviseAircraftAndDepartTime = false"
            >
              <span class="T-size-18">cancel</span>
            </v-btn>
            <v-btn
              class="theme-btn-even btn-save Bsize100"
              text
              @click="SaveReviseAircraftAndDepartureTime()"
            >
              <span class="T-size-18">save</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import fillerdate from "../utils/filterdate";
import feathersClientUOA from "../plugins/feathers-client-uoa";
import { format, addHours } from "date-fns";
// import CompAddPassengerOutbound2 from "../components/checkin/CompAddPassengerOutbound2Checkin";
import CompAddPassengerOutbound2 from "../components/checkin/CompAddPassengerOutboundCheckin2";
export default {
  data: () => ({
    //Add
    alcoholTestBy: "",
    buttonCancel: false,
    buttonSave: false,
    realtimeMonitor: false,
    myInterval: null,

    menuselect_depart_date: false,
    menuselect_depart_time: false,
    menuselect_dest_date: false,
    menuselect_dest_time: false,
    menuselect_leg_eta: false,
    menuselect_leg_etd: false,
    dialogEvent: false,
    dialogSave: false,
    dialogConfirm: false,
    loading: false,
    dialogDelete: false,
    dialogCargo: false,
    activity1: false,
    activity2: false,
    activity3: false,
    activity4: false,
    modeEvent: "",
    depart_date: "",
    depart_time: "",
    dest_date: "",
    dest_time: "",
    mode: "",
    pilot: "",
    copilot: "",
    company: "",
    flighttype: "",
    flightstatus: "",
    aircraft: "",
    aircraftAssignBy: "",
    aircraftAssignTime: "",
    departureairport: "",
    destinationairport: "",
    flightno: "",
    idflight: "",
    legs: "",
    cg_dan_no: "",
    cg_weight: "",
    cg_amount: "",
    cg_contact: "",
    cg_remark: "",
    Destinations: "",
    ref_id: "",
    sumbodyweight: 0,
    sumbaggageweight: 0,
    sumcargo: 0,
    sumTotal: 0,
    itemsPilot: {},
    itemsCoPilot: [],
    itemsDataFlight: [],
    itemsListAircraft: [],
    itemsListCompany: [],
    itemsListFlightType: [],
    itemsListFlightStatus: [],

    itemsListTerminal: [],
    terminal: "",
    itemsListCheckInVideo: [],
    videoCheckin: "",

    itemsListPilot: [],
    itemsListCoPilot: [],
    itemsListLeg: [],
    itemsDataBooking: [],
    chooseItemLegs: null,
    chooseItemLegIndex: null,
    chooseItemCargo: null,
    chooseItemCargoIndex: null,
    itemsDataLegs: [],
    itemsDataCargo: [],

    ArrlistAddLegs: [],
    listAddCargo: [],
    ArrLegs: [],
    userdata: "",
    itemsListFlightType: [
      "Passenger revenue",
      "Aerial work revenue",
      "Maintenance",
      "Training",
      "Reposition",
      "VIP",
      "Others",
    ],
    itemsCalWeightFlight: [],
    sumfromOutboundPassenger: 0,
    sumfromInboundPassenger: 0,
    sumfromOutboundPassengerBaggage: 0,
    CountfromOutboundPassengerBaggage: 0,
    CountfromOutboundPassengerCargo: 0,
    sumfromInboundPassengerBaggage: 0,
    ////////////////report///////////////
    dataLegs: [],
    dataLegsNew: "",

    aircarftName: [],
    ArrListPassenger: [],
    ArrListPassenger_Manifest: [],
    listPassengers: [],
    listPassengers_Manifest: [],
    ////////////////Weight Passenger///////////////
    totalPax: "",
    totalBody_KG_Out: 0,
    totalBaggage_KG_Out: 0,
    totalBody_LBS_Out: 0,
    totalBaggage_LBS_Out: 0,
    sumtotal_KG_Out: 0,
    sumtotal_LBS_Out: 0,
    sumTotalBaggage_Out:0,
    ArrDataCargo: [],
    listCargos_Manifest: [],
    ////////////////Weight Cargo///////////////
    totalCargo_KG: 0,
    totalCargo_amount: 0,
    totalCargo_LBS: 0,
    available_payload: "",
    available_payloadLbs: "",
    //---------------------------------

    //Add
    itemsListCustomer: [],
    customer: "",

    dialogReviseAircraftAndDepartTime: false,
    revise_aircraft: "",
    menuselect_depart_date_revise: false,
    depart_date_revise: "",
    depart_time_revise: "",
    depart_airport: "",
    dest_airport: "",
    //ไม่เคยมีพึ่งแอด 20210520
    itemsListAirport: null,
    reviseNo: null,

    readonly_flight: false,
    readonly_pilot: false,
    readonly_eng: false,
    readonly_shore: false,
    readonly_finance: false,
    readonly_checkin: false,
    readonly_super_flight: false,
  }),
  props: [],
  components: {
    CompAddPassengerOutbound2,
  },
  async mounted() {
    // this.userdata = await JSON.parse(localStorage.getItem("user"));
    //Edit
    this.userdata = await this.$CurrentUser.GetCurrentUser();
    await this.enable_disable();
    this.mode = await this.$route.params.mode;
    this.idflight = await this.$route.params.id;

    await feathersClientUOA.service("flight").on("patched", (passenger) => {
      this.DataFlightFromDB();
    });

    await feathersClientUOA.service("cargo").on("created", (passenger) => {
      this.DataCargoFromDB();
      this.SumDataCargo();
    });

    await feathersClientUOA.service("cargo").on("patched", (passenger) => {
      this.DataCargoFromDB();
    });

    await feathersClientUOA.service("cargo").on("removed", (passenger) => {
      this.DataCargoFromDB();
    });

    await this.SelectAllList();
    await this.RenderUI();
  },
  filters: {
    setzoro: function (value) {
      return value === null ? 0 : value;
    },
  },
  computed: {
    formTitle() {
      return this.modeEvent === "create" ? "Add" : "Edit";
    },
  },
  methods: {
    async SelectAllList() {
      try {
        // this.SelectListCustomer();
        // this.SelectListAircraft();
        // this.SelectListAirport();
        // this.SelectListTerminal();
        // this.SelectListCheckInVideo();
        // this.SelectListCompany(); //เอาออก
        // this.SelectListPilot();
        // this.SelectListFlightStatus();

        var data = await feathersClientUOA.service("mastercommand").find({});
        this.master = data[0];

        //Customer
        this.itemsListCustomer = this.master.customer;

        //Aircraft
        this.itemsListAircraft = this.master.aircraft;

        //Airport & Leg
        this.itemsListAirport = this.master.airport;
        this.itemsListLeg = this.master.airport;

        //Terminal
        this.itemsListTerminal = this.master.terminal;

        //CheckInVideo
        this.itemsListCheckInVideo = this.master.briefCheckInVideo;

        //PILOT & CO PILOT
        this.itemsPilot = this.master.pilot;
        for (let index = 0; index < this.itemsPilot.length; index++) {
          const element = this.itemsPilot[index].pl_name;
          this.itemsListPilot.push(element);
        }
        this.itemsCoPilot = this.master.pilot;

        //Flight Status
        this.itemsListFlightStatus = this.master.flightStatus;
      } catch (error) {
        console.log(
          "SelectAllList ไม่สามารถขอข้อมูลจาก server ได้ /nError : " + error
        );
      }
    },

    async RealtimeMonitor() {
      // if (this.realtimeMonitor) {
      //   await feathersClientUOA
      //     .service("passenger")
      //     .on("created",async (passenger) => {
      //       await this.RenderUI()
      //     });
      //   await feathersClientUOA
      //     .service("passenger")
      //     .on("patched",async (passenger) => {
      //       await this.RenderUI()
      //     });
      //   await feathersClientUOA
      //     .service("baggage")
      //     .on("created",async (passenger) => {
      //       await this.RenderUI()
      //     });
      //   await feathersClientUOA
      //     .service("baggage")
      //     .on("patched",async (passenger) => {
      //       await this.RenderUI()
      //     });
      //   await feathersClientUOA
      //     .service("alcoholtest")
      //     .on("created",async (passenger) => {
      //       await this.RenderUI()
      //     });
      // } else {
      //   await feathersClientUOA
      //     .service("passenger")
      //     .removeListener("created");
      //   await feathersClientUOA
      //     .service("passenger")
      //     .removeListener("patched");
      //     await feathersClientUOA
      //     .service("baggage")
      //     .removeListener("created");
      //   await feathersClientUOA
      //     .service("baggage")
      //     .removeListener("patched");
      //     await feathersClientUOA
      //     .service("alcoholtest")
      //     .removeListener("created");
      // }
    },
    async FlightClosed() {
      await this.SaveEditToDB();
      // await this.$Notification.FlightClosedCheckin(this.idflight);
      this.$Notification.FlightClosedCheckin(this.idflight);
    },
    async enable_disable() {
      if (this.userdata.r_id == 4) {
        this.readonly_flight = true;
      } else if (this.userdata.r_id == 12) {
        this.readonly_pilot = true;
      } else if (this.userdata.r_id == 9) {
        this.readonly_eng = true;
      } else if (this.userdata.r_id == 2) {
        this.readonly_shore = true;
      } else if (this.userdata.r_id == 14) {
        this.readonly_finance = true;
      } else if (this.userdata.r_id == 5) {
        this.readonly_checkin = false;
      } else if (this.userdata.r_id == 21) {
        this.readonly_super_flight = true;
      }
    },
    async RenderUI() {
      console.log("RenderUI");
      //Add
      this.buttonCancel = false;
      this.buttonSave = false;
      await this.DataFlightFromDB();
      await this.DataLegsFromDB();
      await this.DataPassengerFromDB();
      await this.DataCargoFromDB();
      this.SumDataCargo();
      // await this.countleg();
    },
    async SelectListPassengerBAC() {
      try {
        var q = {};
        q.flightid = this.idflight;
        var res = await feathersClientUOA
          .service("reportalcohol")
          .find({ query: q });
        this.ArrListPassenger = res;
      } catch (error) {
        console.log(
          "SelectListPassengerBAC ไม่สามารถขอข้อมูลจาก server ได้ /nError : " +
            error
        );
      }

      if (this.ArrListPassenger[0].f_flight_no != undefined) {
        this.alcoholTestBy = this.ArrListPassenger[0].value[0].by;
        for (let j = 0; j < 12; j++) {
          if (j < this.ArrListPassenger.length) {
            let temperature = "";
            let alcohol1 = "";
            let alcohol1Time = "";
            let alcohol2 = "";
            let alcohol2Time = "";
            let alcohol3 = "";
            let alcohol3Time = "";

            if (this.ArrListPassenger[j].value.length == 1) {
              temperature = parseFloat(
                this.ArrListPassenger[j].value[0].temp
              ).toFixed(2);
              alcohol1 = this.ArrListPassenger[j].value[0].al;
              if (this.ArrListPassenger[j].value[0].time !== null) {
                alcohol1Time = format(
                  new Date(this.ArrListPassenger[j].value[0].time),
                  "HH:mm"
                );
              }
            } else if (this.ArrListPassenger[j].value.length == 2) {
              temperature = parseFloat(
                this.ArrListPassenger[j].value[0].temp
              ).toFixed(2);
              alcohol1 = this.ArrListPassenger[j].value[0].al;
              if (this.ArrListPassenger[j].value[0].time !== null) {
                alcohol1Time = format(
                  new Date(this.ArrListPassenger[j].value[0].time),
                  "HH:mm"
                );
              }
              alcohol2 = this.ArrListPassenger[j].value[1].al;
              if (this.ArrListPassenger[j].value[1].time != null) {
                alcohol2Time = format(
                  new Date(this.ArrListPassenger[j].value[1].time),
                  "HH:mm"
                );
              }
            } else if (this.ArrListPassenger[j].value.length == 3) {
              temperature = this.ArrListPassenger[j].value[0].temp;
              alcohol1 = this.ArrListPassenger[j].value[0].al;
              if (this.ArrListPassenger[j].value[0].time !== null) {
                alcohol1Time = format(
                  new Date(this.ArrListPassenger[j].value[0].time),
                  "HH:mm"
                );
              }
              alcohol2 = this.ArrListPassenger[j].value[1].al;
              if (this.ArrListPassenger[j].value[1].time !== null) {
                alcohol2Time = format(
                  new Date(this.ArrListPassenger[j].value[1].time),
                  "HH:mm"
                );
              }
              alcohol3 = this.ArrListPassenger[j].value[2].al;
              if (this.ArrListPassenger[j].value[2].time != null) {
                alcohol3Time = format(
                  new Date(this.ArrListPassenger[j].value[2].time),
                  "HH:mm"
                );
              }
            } else if (
              this.ArrListPassenger[j].value.length == 0 ||
              this.ArrListPassenger[j].value.length == null
            ) {
              temperature = null;
              alcohol1 = null;
              alcohol1Time = null;
            }

            let temperatureLimit = "";
            let alcoholTest1 = "";
            let alcoholTest2 = "";
            let alcoholTest3 = "";

            if (temperature !== "" && temperature !== "NaN") {
              temperatureLimit = parseFloat(temperature).toFixed(2);
            }

            if (alcohol1 !== "" && alcohol1 !== null) {
              if(alcohol1 < 0){
                alcoholTest1 = "N/A";
                alcohol1Time = null;
              }else{
                alcoholTest1 = parseFloat(alcohol1).toFixed(2);
              }
            }
            if (alcohol2 !== "" && alcohol2 !== null) {
              if(alcohol2 < 0){
                alcoholTest2 = "N/A";
                alcohol2Time = null;
              }else{
                alcoholTest2 = parseFloat(alcohol2).toFixed(2);
              }
            }
            if (alcohol3 !== "" && alcohol3 !== null) {
              if(alcohol3 < 0){
                alcoholTest3 = "N/A";
                alcohol3Time = null;
              }else{
                alcoholTest3 = parseFloat(alcohol3).toFixed(2);
              }
            }

            let offloadName = "";
            let styleOffload = "";
            let offloadRemark = "";
            if (this.ArrListPassenger[j].ol_id != null) {
              styleOffload = "lineThrough";
              offloadName = this.ArrListPassenger[j].ol_name;
            }
            if (this.ArrListPassenger[j].ol_name != null) {
              // offloadRemark = this.ArrListPassenger[j].p_offload_remark;
              offloadRemark = this.ArrListPassenger[j].ol_name;
            }

            this.listPassengers.push({
              No: parseInt(j) + 1,
              FullName: this.ArrListPassenger[j].name,
              CompanyName: this.ArrListPassenger[j].company,
              Destination: this.ArrListPassenger[j].destination,
              Temp: temperatureLimit,
              Alcohol1: alcoholTest1,
              Time1: alcohol1Time,
              Alcohol2: alcoholTest2,
              Time2: alcohol2Time,
              Alcohol3: alcoholTest3,
              Time3: alcohol3Time,
              OffloadName: offloadName,
              OffloadRemark: offloadRemark,
              OffloadStyle: styleOffload,
            });
          } else {
            this.listPassengers.push({
              No: parseInt(j) + 1,
              FullName: "",
              CompanyName: "",
              Destination: "",
              Temp: "",
              Alcohol1: "",
              Time1: "",
              Alcohol2: "",
              Time2: "",
              Alcohol3: "",
              Time3: "",
              OffloadName: "",
              OffloadRemark: "",
              OffloadStyle: "",
            });
          }
        }
      }
    },
    async SelectListManifest() {
      //Reset ค่า
      this.listCargos_Manifest = [];
      this.sumtotal_KG_Out = 0;
      this.sumtotal_LBS_Out = 0;
      this.sumTotalBaggage_Out = 0;
      this.totalCargo_KG = 0;
      this.totalCargo_amount = 0;
      this.totalCargo_LBS = 0;

      ////////////////Weight Passenger///////////////
      this.totalPax = "";
      this.totalBody_KG_Out = 0;
      this.totalBaggage_KG_Out = 0;
      this.totalBody_LBS_Out = 0;
      this.totalBaggage_LBS_Out = 0;

      ////////////////Weight Cargo///////////////
      (this.listCargos_Manifest = []), (this.totalCargo_KG = 0);
      this.totalCargo_LBS = 0;

      try {
        const q = {};
        q.f_id = this.$route.params.id;
        q.$eager = "[aircrafts]";
        var res = await feathersClientUOA.service("flight").find({ query: q });
        //aircarftName decoration: "lineThrough",
        if(res.data[0].aircrafts != null){
          this.aircarftName = res.data[0].aircrafts.ac_name;
        }
      } catch (error) {
        console.log(error);
      }

      try {
        var queryPassenger = {};
        queryPassenger.flightid = this.idflight;
        var res = await feathersClientUOA
          .service("reportpassengerbooking")
          .find({ query: queryPassenger });
        this.ArrListPassenger_Manifest = res[0].Outbound;
        this.ArrListPassenger_Manifest = this.ArrListPassenger_Manifest.filter(
          (x) => x.retire == "0"
        );
      } catch (error) {
        console.log(
          "SelectListManifest ไม่สามารถขอข้อมูลจาก server ได้ /nError : " +
            error
        );
      }

      this.totalPax = this.ArrListPassenger_Manifest.filter(
        (x) => x.p_offload != "1"
      ).length;
      var bodyKG = 0;
      var baggageKG = 0;
      var baggageTotal = 0;
      var bodyLBS = 0;
      var baggageLBS = 0;
      for (let j = 0; j < 15; j++) {
        // console.log(
        //   j + " " + JSON.stringify(this.ArrListPassenger_Manifest[j])
        // );

        var no = "-";
        if (this.ArrListPassenger_Manifest[j] != undefined) {
          no = (parseInt(j) + 1).toString();
        }

        if (j < this.ArrListPassenger_Manifest.length) {
          var seat = "";
          if (this.ArrListPassenger_Manifest[j].p_seat_no == null) {
            seat = "-";
          } else {
            seat = this.ArrListPassenger_Manifest[j].p_seat_no + "";
          }

          if (this.ArrListPassenger_Manifest[j].p_offload != "1") {
            this.totalBody_KG_Out +=
              this.ArrListPassenger_Manifest[j].p_body_weight;
            this.totalBaggage_KG_Out +=
              this.ArrListPassenger_Manifest[j].p_baggage_weight;
          }

          var styleOffload = "";
          var styleOffloadName = "";

          if (
            this.ArrListPassenger_Manifest[j].p_offload != null &&
            this.ArrListPassenger_Manifest[j].ol_id != null
          ) {
            styleOffload = "lineThrough";
            styleOffloadName = this.ArrListPassenger_Manifest[j].ol_name;
            bodyKG = 0;
            baggageKG = 0;
            baggageTotal = 0;
          } else {
            styleOffload = "";
            styleOffloadName = "";
            bodyKG = this.ArrListPassenger_Manifest[j].p_body_weight;
            baggageKG = this.ArrListPassenger_Manifest[j].p_baggage_weight;
            baggageTotal = this.ArrListPassenger_Manifest[j].p_total_baggage;
            this.sumTotalBaggage_Out = this.sumTotalBaggage_Out + baggageTotal;
          }

          //เพิ่ม 22/12/01
          if(bodyKG == null){
            bodyKG = 0;
          }
          if(baggageKG == null){
            baggageKG = 0;
          }

          let offloadNew = "";
          let status = this.ArrListPassenger_Manifest[j].p_offload;
          if (
            this.ArrListPassenger_Manifest[j].p_offload != null &&
            this.ArrListPassenger_Manifest[j].ol_id != null
          ) {
            offloadNew =
              this.ArrListPassenger_Manifest[j].ol_name +
              " " +
              this.ArrListPassenger_Manifest[j].p_offload_remark;
          } else {
            offloadNew = "";
          }

          if (this.ArrListPassenger_Manifest[j].p_remark == "") {
            this.listPassengers_Manifest.push({
              // No: parseInt(j) + 1,
              No: no,
              FullName: this.ArrListPassenger_Manifest[j].u_name,
              FullNameColor: "#3F3395",
              CompanyName: this.ArrListPassenger_Manifest[j].c_name,
              Destination: this.ArrListPassenger_Manifest[j].to,
              WeightBody_Kg: bodyKG,
              WeightBaggage_Kg: baggageKG,
              WeightBody_Lbs: (bodyKG * 2.2).toFixed(0),
              WeightBaggage_Lbs: (baggageKG * 2.2).toFixed(0),
              Baggage_total: baggageTotal,
              Offload_Status: this.ArrListPassenger_Manifest[j].p_offload,
              Offload_Name: offloadNew,
              Style: styleOffload,
              SeatNo: seat,
            });
          } else {
            //alert("p_remark != null" + offloadNew + " " + styleOffload)
            this.listPassengers_Manifest.push({
              //No: parseInt(j) + 1,
              No: no,
              FullName:
                this.ArrListPassenger_Manifest[j].u_name +
                this.ArrListPassenger_Manifest[j].p_remark,
              FullNameColor: "red",
              CompanyName: this.ArrListPassenger_Manifest[j].c_name,
              Destination: this.ArrListPassenger_Manifest[j].to,
              WeightBody_Kg: bodyKG,
              WeightBaggage_Kg: baggageKG,
              WeightBody_Lbs: (bodyKG * 2.2).toFixed(0),
              WeightBaggage_Lbs: (baggageKG * 2.2).toFixed(0),
              Baggage_total: baggageTotal,
              Offload_Status: this.ArrListPassenger_Manifest[j].p_offload,
              Offload_Name: offloadNew,
              Style: styleOffload,
              SeatNo: seat,
            });
          }
        } else {
          this.listPassengers_Manifest.push({
            //No: parseInt(j) + 1,
            No: no,
            FullName: "",
            CompanyName: "",
            Destination: "",
            WeightBody_Kg: "",
            WeightBaggage_Kg: "",
            WeightBody_Lbs: "",
            WeightBaggage_Lbs: "",
            Baggage_total:"",
            Offload_Status: "",
            Offload_Name: "",
            Style: "",
            SeatNo: "",
          });
        }

        this.totalBody_LBS_Out = (
          parseFloat(this.totalBody_KG_Out) * 2.2
        ).toFixed(0);
        this.totalBaggage_LBS_Out = (
          parseFloat(this.totalBaggage_KG_Out) * 2.2
        ).toFixed(0);

        this.sumtotal_KG_Out = this.totalBody_KG_Out + this.totalBaggage_KG_Out;
        this.sumtotal_LBS_Out =
          parseInt(this.totalBody_LBS_Out) +
          parseInt(this.totalBaggage_LBS_Out);
      }

      //console.log(JSON.stringify(this.listPassengers_Manifest))

      //Get Cargo
      await this.DataCargoFromDB();

      for (let c = 0; c < 10; c++) {
        if (c < this.listAddCargo.length) {
          this.totalCargo_KG += this.listAddCargo[c].cg_weight;

          let dataAdd = {
            No: parseInt(c) + 1,
            // DANNo: "N/A",
            DANNo: this.listAddCargo[c].cg_dan_no,
            Description: this.listAddCargo[c].cg_remark,
            Consigned: this.listAddCargo[c].cg_contact,
            Destination: this.listAddCargo[c].Destinations.ap_name,
            KgWeight: this.listAddCargo[c].cg_weight.toFixed(0),
            LbsWeight: (this.listAddCargo[c].cg_weight * 2.2).toFixed(0),
            Amount: this.listAddCargo[c].cg_amount,
          };
          this.listCargos_Manifest.push(dataAdd);
        } else {
          let dataAdd = {
            No: parseInt(c) + 1,
            DANNo: "",
            Description: "",
            Consigned: "",
            Destination: "",
            KgWeight: null,
            LbsWeight: null,
            Amount: null,
          };
          this.listCargos_Manifest.push(dataAdd);
        }
      }
      this.totalCargo_LBS = this.totalCargo_KG * 2.2;
    },
    async SelectListAirport() {
      try {
        var q = {};
        q.retire = "0";
        var res = await feathersClientUOA.service("airports").find({ query: q });
        this.itemsListAirport = res.data;
        this.itemsListLeg = res.data;
      } catch (error) {
        console.log(
          "SelectListAirport ไม่สามารถขอข้อมูลจาก server ได้ /nError : " + error
        );
      }
    },
    async SelectListAircraft() {
      try {
        var res = await feathersClientUOA.service("aircrafts").find({});
        this.itemsListAircraft = res.data;
      } catch (error) {
        console.log(
          "SelectListAircraft ไม่สามารถขอข้อมูลจาก server ได้ /nError : " +
            error
        );
      }
    },
    async SelectListPilot() {
      try {
        var res = await feathersClientUOA.service("pilot").find({});
        this.itemsPilot = res.data;

        for (let index = 0; index < this.itemsPilot.length; index++) {
          const element = this.itemsPilot[index].pl_name;
          this.itemsListPilot.push(element);
        }
      } catch (error) {
        console.log(
          "SelectListPilot ไม่สามารถขอข้อมูลจาก server ได้ /nError : " + error
        );
      }
    },
    async SelectListTerminal() {
      try {
        var q = {};
        q.retire = 0;
        var res = await feathersClientUOA
          .service("terminal")
          .find({ query: q });
        this.itemsListTerminal = res.data;
      } catch (error) {
        console.log(
          "SelectListTerminal ไม่สามารถขอข้อมูลจาก server ได้ /nError : " +
            error
        );
      }
    },
    async SelectListCheckInVideo() {
      try {
        var q = {};
        q.$sort = {
          v_id: 1,
        };
        var res = await feathersClientUOA
          .service("filevideo")
          .find({ query: q });
        this.itemsListCheckInVideo = res.data;
        this.videoCheckin = this.itemsListCheckInVideo[0];
      } catch (error) {
        console.log(
          "SelectListCheckInVideo ไม่สามารถขอข้อมูลจาก server ได้ /nError : " +
            error
        );
      }
    },
    async SelectListFlightStatus() {
      try {
        //Add query: {$sort: { fs_id: 1}} นอกไปมาก
        var res = await feathersClientUOA
          .service("flightstatus")
          .find({ query: { $sort: { fs_id: 1 } } });
        this.itemsListFlightStatus = res.data;
      } catch (error) {
        console.log(
          "SelectListFlightStatus ไม่สามารถขอข้อมูลจาก server ได้ /nError : " +
            error
        );
      }
    },
    async SelectListCompany() {
      try {
        var res = await feathersClientUOA.service("company").find({});

        this.itemsListCompany = res.data;
      } catch (error) {
        console.log(
          "SelectListCompany ไม่สามารถขอข้อมูลจาก server ได้ /nError : " + error
        );
      }
    },

    async SelectListCustomer() {
      try {
        var res = await feathersClientUOA.service("customer").find({});

        this.itemsListCustomer = res.data;
      } catch (error) {
        console.log(
          "SelectListCustomer ไม่สามารถขอข้อมูลจาก server ได้ /nError : " +
            error
        );
      }
    },
    async DataFlightFromDB() {
      try {
        // if(this.modeEvent == "edit")
        var q = {};
        q.f_id = this.idflight;
        q.$eager = "[customer,arrivalairport,departairport]";
        var res = await feathersClientUOA.service("flight").find({ query: q });
        this.itemsDataFlight = res.data[0];

        //alert("DataFlightFromDB\nap_depart_date : " + this.itemsDataFlight.ap_depart_date + "\n" + "ap_dest_date : " + this.itemsDataFlight.ap_dest_date);
        this.depart_date = this.itemsDataFlight.ap_depart_date.substring(0, 10);
        this.depart_time = this.itemsDataFlight.ap_depart_date.substring(
          11,
          16
        );
        this.dest_date = this.itemsDataFlight.ap_dest_date.substring(0, 10);
        this.dest_time = this.itemsDataFlight.ap_dest_date.substring(11, 16);
        this.terminal = this.itemsDataFlight.tm_id;
        if (this.itemsDataFlight.v_id != null) {
          this.videoCheckin = this.itemsDataFlight.v_id;
        } else {
          this.videoCheckin = this.itemsListCheckInVideo[0];
        }
        this.depart_airport = this.itemsDataFlight.departairport.ap_name;
        this.dest_airport = this.itemsDataFlight.arrivalairport.ap_name;
        this.flightno = this.itemsDataFlight.f_flight_no;
        this.company = this.itemsDataFlight.c_id;
        this.flighttype = this.itemsDataFlight.f_type_of_flight;
        this.flightstatus = { fs_id: this.itemsDataFlight.fs_id };
        this.pilot = this.itemsDataFlight.f_pilot_name;
        this.copilot = this.itemsDataFlight.f_copilot_name;
        this.aircraft = this.itemsDataFlight.ac_id;
        this.aircraftAssignBy = this.itemsDataFlight.f_assing_aircraft_by;
        this.aircraftAssignTime = this.itemsDataFlight.f_assing_aircraft_date;
        this.departureairport = this.itemsDataFlight.ap_departairport_id;
        this.destinationairport = this.itemsDataFlight.ap_destairport_id;
        if (this.itemsDataFlight.f_available_payload != null) {
          this.available_payload =
            this.itemsDataFlight.f_available_payload.toFixed(0);
          this.available_payloadLbs = (
            this.itemsDataFlight.f_available_payload * 2.2
          ).toFixed(0);
        }

        this.customer = {
          o_id: this.itemsDataFlight.customer.o_id,
          o_name: this.itemsDataFlight.customer.o_name,
        };
      } catch (error) {
        console.log(
          "DataFlightFromDB ไม่สามารถขอข้อมูลจาก server ได้ /nError : " + error
        );
      }
    },
    async DataLegsFromDB() {
      await this.countleg();

      //เดิม
      // try {
      //   var q = {};
      //   q.f_id = this.idflight;
      //   q.$eager = "[airport]";
      //   q.retire = "0";

      //   var res = await feathersClientUOA.service("leg").find({ query: q });
      //   this.itemsDataLegs = res.data;

      //   this.itemsDataLegs.forEach((element) => {
      //     var newArrayBinding = {};
      //     newArrayBinding["activity1"] = element.l_activity1 === "1" ? "S/D Refuel" : null;
      //     newArrayBinding["activity2"] = element.l_activity2 === "1" ? "S/D Refuel and HLO familiarize": null;
      //     newArrayBinding["activity3"] = element.l_activity3 === "1" ? "S/D FOR JET A1 INSPECTION" : null;
      //     newArrayBinding["activity4"] = element.l_activity4 === "1" ? "S/D for Helideck Inspec" : null;
      //     // newArrayBinding["activity4"] = element.l_activity4 === "1" ? "EDRILL-1" : null;

      //     newArrayBinding["legs"] = element.airport;
      //     for (let index = 0; index < this.ArrLegs.length; index++) {
      //       if (element.airport.ap_name == this.ArrLegs[index].ap_name) {
      //         newArrayBinding["l_ob"] = this.ArrLegs[index].l_ob;
      //         newArrayBinding["l_ib"] = this.ArrLegs[index].l_ib;
      //       }
      //     }
      //     this.ArrlistAddLegs.push(newArrayBinding);
      //   });
      // } catch (error) {
      //   console.log(error);
      //   alert("ไม่สามารถขอข้อมูลจาก server ได้");
      // }

      //ใหม่
      try {
        var q = {};
        q.f_id = this.idflight;
        q.$sort = {
          l_id: 1,
        };
        var res = await feathersClientUOA
          .service("viewcountleg")
          .find({ query: q });
        var viewcountleg = res.data;

        this.ArrlistAddLegs = [];
        viewcountleg.forEach((element) => {
          var activity1Str = "";
          var activity2Str = "";
          var activity3Str = "";
          var activity4Str = "";
          if (element.l_activity1 === "1") {
            activity1Str = "S/D Refuel";
          } else {
            activity1Str = null;
          }
          if (element.l_activity2 === "1") {
            activity2Str = "S/D Refuel and HLO familiarize";
          } else {
            activity2Str = null;
          }
          if (element.l_activity3 === "1") {
            activity3Str = "S/D FOR JET A1 INSPECTION";
          } else {
            activity3Str = null;
          }
          if (element.l_activity4 === "1") {
            activity4Str = "S/D for Helideck Inspec";
          } else {
            activity4Str = null;
          }
          var newData = {
            f_id: element.f_id,
            ap_id: element.ap_id,
            activity1: activity1Str,
            activity2: activity2Str,
            activity3: activity3Str,
            activity4: activity4Str,
            ap_name: element.ap_name,
            l_ob: element.l_ob,
            l_ib: element.l_ib,
            ap_color: element.ap_color,
            ap_image_base64: element.ap_image_base64,
          };
          this.ArrlistAddLegs.push(newData);
        });
        //console.log("ArrlistAddLegs : " + JSON.stringify(this.ArrlistAddLegs))
      } catch (error) {
        console.log(error);
      }

      var NewdataLeg = "";
      for (let j = 0; j < this.itemsDataLegs.length; j++) {
        if (j < this.itemsDataLegs.length - 1) {
          NewdataLeg += this.itemsDataLegs[j].ap_name + " - ";
        } else {
          NewdataLeg += this.itemsDataLegs[j].ap_name;
        }
      }
      this.dataLegs.push(NewdataLeg);
    },
    async DataPassengerFromDB() {
      try {
        await this.$refs.CompAddPassengerOutbound2.DataPassengerFromDB(
          this.idflight
        );
      } catch (error) {
        console.log(error);
      }
    },
    async DataCargoFromDB() {
      try {
        var q = {};
        q.f_id = this.idflight;
        q.$eager = "[airport]";
        q.retire = "0";
        var res = await feathersClientUOA.service("cargo").find({ query: q });
        this.itemsDataCargo = res.data;
        this.listAddCargo = [];
        this.itemsDataCargo.forEach((element) => {
          var newArrayBinding = {};
          newArrayBinding["Idflightcargo"] = element.cg_id;
          newArrayBinding["cg_dan_no"] = element.cg_dan_no;
          newArrayBinding["cg_weight"] = element.cg_weight;
          newArrayBinding["cg_amount"] = element.cg_amount;
          newArrayBinding["cg_contact"] = element.cg_contact;
          newArrayBinding["cg_remark"] = element.cg_remark;
          newArrayBinding["Destinations"] = element.airport;
          this.listAddCargo.push(newArrayBinding);
          // this.SumDataTotal();
          this.SumDataCargo();
        });
      } catch (error) {
        console.log(
          "DataCargoFromDB ไม่สามารถขอข้อมูลจาก server ได้ /nError : " + error
        );
      }
    },
    async SaveCargo() {
      if (this.modeEvent == "create") {
        if(this.cg_dan_no != "" && this.cg_weight != "" && this.cg_amount != "" && this.cg_contact != "" && this.cg_remark != ""){
          let DataAdd = {
            f_id: this.idflight,
            cg_dan_no: this.cg_dan_no,
            cg_weight: this.cg_weight,
            cg_amount: this.cg_amount,
            cg_contact: this.cg_contact,
            cg_remark: this.cg_remark,
            ap_id: this.Destinations.ap_id,
            retire: 0,
          };
          await this.CreateCargo(DataAdd);
          this.dialogCargo = false;
        }
      } else {
        if(this.cg_dan_no != "" && this.cg_weight != "" && this.cg_amount != "" && this.cg_contact != "" && this.cg_remark != ""){
          let cargoID =
            this.listAddCargo[this.chooseItemCargoIndex].Idflightcargo;
          let dataUpdate = {
            cg_dan_no: this.cg_dan_no,
            cg_weight: this.cg_weight,
            cg_amount: this.cg_amount,
            cg_contact: this.cg_contact,
            cg_remark: this.cg_remark,
            ap_id: this.Destinations.ap_id,
            retire: 0,
          };
          await this.UpdateCargotodb(cargoID, dataUpdate);
          this.dialogCargo = false;
        }
      }
    },
    async addItemCargo() {
      this.modeEvent = "create";
      this.dialogCargo = true;
      this.Destinations = this.itemsListAirport[0];
      this.cg_dan_no = "";
      this.cg_weight = "";
      this.cg_amount = "";
      this.cg_contact = "";
      this.cg_remark = "";
    },
    async EditItemCargo(itemCargo, index) {
      this.modeEvent = "edit";
      this.dialogCargo = true;
      this.Destinations = itemCargo.Destinations;
      this.cg_dan_no = itemCargo.cg_dan_no;
      this.cg_weight = itemCargo.cg_weight;
      this.cg_amount = itemCargo.cg_amount;
      this.cg_contact = itemCargo.cg_contact;
      this.cg_remark = itemCargo.cg_remark;
      this.chooseItemCargo = itemCargo;
      this.chooseItemCargoIndex = index;
    },
    async deleteItemCargo(itemCargo) {
      // const index = this.listAddCargo.indexOf(itemCargo);
      // if (index > -1) {
      //   this.listAddCargo.splice(index, 1);
      // }

      //Edit
      let cargoID = itemCargo.Idflightcargo;
      await feathersClientUOA.service("cargo").remove(cargoID);
      this.DataCargoFromDB();
    },
    async SaveEditToDB() {
      //Add
      this.buttonCancel = true;
      this.buttonSave = true;

      var DataAdd = {
        tm_id: this.terminal.tm_id,
        v_id: this.videoCheckin.v_id,
        fs_id: this.flightstatus.fs_id,
        mb: this.userdata.FullName,
        md: format(new Date(), "yyyy-MMM-dd HH:mm:ss"),
      };

      var res = await feathersClientUOA
        .service("flight")
        .patch(this.idflight, DataAdd);

      // try {
      //   await this.$refs.CompAddPassengerOutbound2.SavePassengerEditToDB(
      //     this.idflight
      //   );
      // } catch (error) {
      //   console.log(error);
      // }

      // this.SaveCargoEditToDB();
      this.dialogSave = false;
      this.dialogConfirm = true;
      // this.GotoListCheckin();
    },
    async SaveCompleted() {
      this.dialogConfirm = false;
      await this.RenderUI();
    },

    async UpdateCargotodb(Idcargo, dataUpdate) {
      try {
        await feathersClientUOA.service("cargo").patch(Idcargo, dataUpdate);
      } catch (error) {
        console.log(error);
      }
    },
    async CreateCargo(DataAdd) {
      try {
        var res = await feathersClientUOA.service("cargo").create(DataAdd);
      } catch (error) {
        console.log(error);
      }
    },
    async countleg() {
      try {
        var q = {};
        q.f_id = this.idflight;

        var res = await feathersClientUOA
          .service("viewcountleg")
          .find({ query: q });
        this.ArrLegs = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    async GotoListCheckin() {
      this.$router.push("/checkinactive");
    },
    async BodyOut(dataOut) {
      this.sumfromOutboundPassenger = dataOut;
      this.BodyWeight();
    },
    BaggageOut(dataOut) {
      this.sumfromOutboundPassengerBaggage = dataOut;
      this.BaggageWeight();
    },
    async CountBaggageOut(dataOut) {
      this.CountfromOutboundPassengerBaggage = dataOut;
    },

    async BodyWeight() {
      this.sumbodyweight = parseFloat(this.sumfromOutboundPassenger);
      this.SumDataTotal();
    },
    async BaggageWeight() {
      this.sumbaggageweight = parseFloat(this.sumfromOutboundPassengerBaggage);
      this.SumDataTotal();
    },
    async SumDataCargo() {
      this.sumcargo = 0;
      this.totalCargo_amount = 0;
      this.listAddCargo.forEach((element) => {
        this.sumcargo += parseFloat(element.cg_weight);
        this.totalCargo_amount += element.cg_amount;
      });
      this.sumcargo = parseFloat(this.sumcargo);
      this.SumDataTotal();
    },
    async SumDataTotal() {
      this.sumTotal =
        parseFloat(this.sumcargo) +
        parseFloat(this.sumbodyweight) +
        parseFloat(this.sumbaggageweight);
    },
    Back() {
      this.$router.go(-1);
    },
    async BAC_Report() {
      await this.SelectListPassengerBAC();
      var uoaimage = await this.$LogoService.GetLogoBaseurl64(1);
      var customerlogo = await this.$LogoService.GetLogoBaseurl64(
        this.itemsDataFlight.customer.o_id
      );

      let outboundPassengersFromSKL = null;
      let remarkBACReportNo = "";
      let documentBACReportNo = "";

      //Add
      var q = {};
      q.f_id = this.idflight;
      var res = await feathersClientUOA
        .service("viewcheckinpassenger")
        .find({ query: q });
      let customerLimit = res.data[0];

      if (this.customer.o_name == "CPOC") {
        remarkBACReportNo =
          "*All service company BAC test cut off " +
          parseFloat(customerLimit.o_alcohol_limit).toFixed(2) +
          "% or 0 mg/dl (3 time every 15 min.)";
        documentBACReportNo = "OPS-FM-91 Issue 01 Revision 01";
      } else if (this.customer.o_name == "CHOC") {
        remarkBACReportNo =
          "*All service company BAC test cut off " +
          parseFloat(customerLimit.o_alcohol_limit).toFixed(2) +
          "% or 0 mg/dl (3 time every 15 min.)";
        documentBACReportNo = "OPS-FM-98 Issue 01 Revision 00";
      } else if (this.customer.o_name == "PTT") {
        remarkBACReportNo =
          "*All service company BAC test cut off " +
          parseFloat(customerLimit.o_alcohol_limit).toFixed(2) +
          "% or 0 mg/dl (2nd times in 30 mins)";
        documentBACReportNo = "OPS-FM-101 Issue 01 Revision 00";
      } else if (this.customer.o_name == "MUBADALA") {
        remarkBACReportNo =
          "*All service company BAC test cut off 0.00% or 0 mg/dl (0 mg/100ml.)";
      }

      if (this.customer.o_name == "CPOC" || this.customer.o_name == "CHOC") {
        outboundPassengersFromSKL = {
          widths: [
            "auto",
            148,
            "auto",
            "auto",
            "auto",
            "auto",
            "auto",
            "auto",
            "auto",
            "auto",
            "auto",
            "auto",
          ],
          body: [
            [
              { text: "No.", fillColor: "#64B5F6" },
              { text: "Passenger Name", fillColor: "#64B5F6" },
              { text: "Company", fillColor: "#64B5F6" },
              { text: "Destination", fillColor: "#64B5F6" },
              { text: "Temp", fillColor: "#64B5F6" },
              { text: "Result#1(mg%BAC)", fillColor: "#FFF59D" },
              { text: "Time", fillColor: "#64B5F6" },
              { text: "Result#2(mg%BAC)", fillColor: "#FFF59D" },
              { text: "Time", fillColor: "#64B5F6" },
              { text: "Result#3(mg%BAC)", fillColor: "#FFF59D" },
              { text: "Time", fillColor: "#64B5F6" },
              { text: "Remark", fillColor: "#64B5F6" },
            ],
            [
              this.listPassengers[0].No,
              {
                text: this.listPassengers[0].FullName,
                alignment: "left",
                decoration: this.listPassengers[0].OffloadStyle,
              },
              {
                text: this.listPassengers[0].CompanyName,
                decoration: this.listPassengers[0].OffloadStyle,
              },
              {
                text: this.listPassengers[0].Destination,
                decoration: this.listPassengers[0].OffloadStyle,
              },
              this.listPassengers[0].Temp,
              this.listPassengers[0].Alcohol1,
              this.listPassengers[0].Time1,
              this.listPassengers[0].Alcohol2,
              this.listPassengers[0].Time2,
              this.listPassengers[0].Alcohol3,
              this.listPassengers[0].Time3,
              this.listPassengers[0].OffloadRemark,
            ],
            [
              this.listPassengers[1].No,
              {
                text: this.listPassengers[1].FullName,
                alignment: "left",
                decoration: this.listPassengers[1].OffloadStyle,
              },
              {
                text: this.listPassengers[1].CompanyName,
                decoration: this.listPassengers[1].OffloadStyle,
              },
              {
                text: this.listPassengers[1].Destination,
                decoration: this.listPassengers[1].OffloadStyle,
              },
              this.listPassengers[1].Temp,
              this.listPassengers[1].Alcohol1,
              this.listPassengers[1].Time1,
              this.listPassengers[1].Alcohol2,
              this.listPassengers[1].Time2,
              this.listPassengers[1].Alcohol3,
              this.listPassengers[1].Time3,
              this.listPassengers[1].OffloadRemark,
            ],
            [
              this.listPassengers[2].No,
              {
                text: this.listPassengers[2].FullName,
                alignment: "left",
                decoration: this.listPassengers[2].OffloadStyle,
              },
              {
                text: this.listPassengers[2].CompanyName,
                decoration: this.listPassengers[2].OffloadStyle,
              },
              {
                text: this.listPassengers[2].Destination,
                decoration: this.listPassengers[2].OffloadStyle,
              },
              this.listPassengers[2].Temp,
              this.listPassengers[2].Alcohol1,
              this.listPassengers[2].Time1,
              this.listPassengers[2].Alcohol2,
              this.listPassengers[2].Time2,
              this.listPassengers[2].Alcohol3,
              this.listPassengers[2].Time3,
              this.listPassengers[2].OffloadRemark,
            ],
            [
              this.listPassengers[3].No,
              {
                text: this.listPassengers[3].FullName,
                alignment: "left",
                decoration: this.listPassengers[3].OffloadStyle,
              },
              {
                text: this.listPassengers[3].CompanyName,
                decoration: this.listPassengers[3].OffloadStyle,
              },
              {
                text: this.listPassengers[3].Destination,
                decoration: this.listPassengers[3].OffloadStyle,
              },
              this.listPassengers[3].Temp,
              this.listPassengers[3].Alcohol1,
              this.listPassengers[3].Time1,
              this.listPassengers[3].Alcohol2,
              this.listPassengers[3].Time2,
              this.listPassengers[3].Alcohol3,
              this.listPassengers[3].Time3,
              this.listPassengers[3].OffloadRemark,
            ],
            [
              this.listPassengers[4].No,
              {
                text: this.listPassengers[4].FullName,
                alignment: "left",
                decoration: this.listPassengers[4].OffloadStyle,
              },
              {
                text: this.listPassengers[4].CompanyName,
                decoration: this.listPassengers[4].OffloadStyle,
              },
              {
                text: this.listPassengers[4].Destination,
                decoration: this.listPassengers[4].OffloadStyle,
              },
              this.listPassengers[4].Temp,
              this.listPassengers[4].Alcohol1,
              this.listPassengers[4].Time1,
              this.listPassengers[4].Alcohol2,
              this.listPassengers[4].Time2,
              this.listPassengers[4].Alcohol3,
              this.listPassengers[4].Time3,
              this.listPassengers[4].OffloadRemark,
            ],
            [
              this.listPassengers[5].No,
              {
                text: this.listPassengers[5].FullName,
                alignment: "left",
                decoration: this.listPassengers[5].OffloadStyle,
              },
              {
                text: this.listPassengers[5].CompanyName,
                decoration: this.listPassengers[5].OffloadStyle,
              },
              {
                text: this.listPassengers[5].Destination,
                decoration: this.listPassengers[5].OffloadStyle,
              },
              this.listPassengers[5].Temp,
              this.listPassengers[5].Alcohol1,
              this.listPassengers[5].Time1,
              this.listPassengers[5].Alcohol2,
              this.listPassengers[5].Time2,
              this.listPassengers[5].Alcohol3,
              this.listPassengers[5].Time3,
              this.listPassengers[5].OffloadRemark,
            ],
            [
              this.listPassengers[6].No,
              {
                text: this.listPassengers[6].FullName,
                alignment: "left",
                decoration: this.listPassengers[6].OffloadStyle,
              },
              {
                text: this.listPassengers[6].CompanyName,
                decoration: this.listPassengers[6].OffloadStyle,
              },
              {
                text: this.listPassengers[6].Destination,
                decoration: this.listPassengers[6].OffloadStyle,
              },
              this.listPassengers[6].Temp,
              this.listPassengers[6].Alcohol1,
              this.listPassengers[6].Time1,
              this.listPassengers[6].Alcohol2,
              this.listPassengers[6].Time2,
              this.listPassengers[6].Alcohol3,
              this.listPassengers[6].Time3,
              this.listPassengers[6].OffloadRemark,
            ],
            [
              this.listPassengers[7].No,
              {
                text: this.listPassengers[7].FullName,
                alignment: "left",
                decoration: this.listPassengers[7].OffloadStyle,
              },
              {
                text: this.listPassengers[7].CompanyName,
                decoration: this.listPassengers[7].OffloadStyle,
              },
              {
                text: this.listPassengers[7].Destination,
                decoration: this.listPassengers[7].OffloadStyle,
              },
              this.listPassengers[7].Temp,
              this.listPassengers[7].Alcohol1,
              this.listPassengers[7].Time1,
              this.listPassengers[7].Alcohol2,
              this.listPassengers[7].Time2,
              this.listPassengers[7].Alcohol3,
              this.listPassengers[7].Time3,
              this.listPassengers[7].OffloadRemark,
            ],
            [
              this.listPassengers[8].No,
              {
                text: this.listPassengers[8].FullName,
                alignment: "left",
                decoration: this.listPassengers[8].OffloadStyle,
              },
              {
                text: this.listPassengers[8].CompanyName,
                decoration: this.listPassengers[8].OffloadStyle,
              },
              {
                text: this.listPassengers[8].Destination,
                decoration: this.listPassengers[8].OffloadStyle,
              },
              this.listPassengers[8].Temp,
              this.listPassengers[8].Alcohol1,
              this.listPassengers[8].Time1,
              this.listPassengers[8].Alcohol2,
              this.listPassengers[8].Time2,
              this.listPassengers[8].Alcohol3,
              this.listPassengers[8].Time3,
              this.listPassengers[8].OffloadRemark,
            ],
            [
              this.listPassengers[9].No,
              {
                text: this.listPassengers[9].FullName,
                alignment: "left",
                decoration: this.listPassengers[9].OffloadStyle,
              },
              {
                text: this.listPassengers[9].CompanyName,
                decoration: this.listPassengers[9].OffloadStyle,
              },
              {
                text: this.listPassengers[9].Destination,
                decoration: this.listPassengers[9].OffloadStyle,
              },
              this.listPassengers[9].Temp,
              this.listPassengers[9].Alcohol1,
              this.listPassengers[9].Time1,
              this.listPassengers[9].Alcohol2,
              this.listPassengers[9].Time2,
              this.listPassengers[9].Alcohol3,
              this.listPassengers[9].Time3,
              this.listPassengers[9].OffloadRemark,
            ],
            [
              this.listPassengers[10].No,
              {
                text: this.listPassengers[10].FullName,
                alignment: "left",
                decoration: this.listPassengers[10].OffloadStyle,
              },
              {
                text: this.listPassengers[10].CompanyName,
                decoration: this.listPassengers[10].OffloadStyle,
              },
              {
                text: this.listPassengers[10].Destination,
                decoration: this.listPassengers[10].OffloadStyle,
              },
              this.listPassengers[10].Temp,
              this.listPassengers[10].Alcohol1,
              this.listPassengers[10].Time1,
              this.listPassengers[10].Alcohol2,
              this.listPassengers[10].Time2,
              this.listPassengers[10].Alcohol3,
              this.listPassengers[10].Time3,
              this.listPassengers[10].OffloadRemark,
            ],
            [
              this.listPassengers[11].No,
              {
                text: this.listPassengers[11].FullName,
                alignment: "left",
                decoration: this.listPassengers[11].OffloadStyle,
              },
              {
                text: this.listPassengers[11].CompanyName,
                decoration: this.listPassengers[11].OffloadStyle,
              },
              {
                text: this.listPassengers[11].Destination,
                decoration: this.listPassengers[11].OffloadStyle,
              },
              this.listPassengers[11].Temp,
              this.listPassengers[11].Alcohol1,
              this.listPassengers[11].Time1,
              this.listPassengers[11].Alcohol2,
              this.listPassengers[11].Time2,
              this.listPassengers[11].Alcohol3,
              this.listPassengers[11].Time3,
              this.listPassengers[11].OffloadRemark,
            ],
          ],
        };
      } else {
        //Only PTT && MUBA
        outboundPassengersFromSKL = {
          widths: [
            "auto",
            148,
            "auto",
            "auto",
            "auto",
            "auto",
            "auto",
            "auto",
            "auto",
            180,
          ],
          body: [
            [
              { text: "No.", fillColor: "#64B5F6" },
              { text: "Passenger Name", fillColor: "#64B5F6" },
              { text: "Company", fillColor: "#64B5F6" },
              { text: "Destination", fillColor: "#64B5F6" },
              { text: "Temp", fillColor: "#64B5F6" },
              { text: "Result#1(mg%BAC)", fillColor: "#FFF59D" },
              { text: "Time", fillColor: "#64B5F6" },
              { text: "Result#2(mg%BAC)", fillColor: "#FFF59D" },
              { text: "Time", fillColor: "#64B5F6" },
              { text: "Remark", fillColor: "#64B5F6" },
            ],
            [
              this.listPassengers[0].No,
              {
                text: this.listPassengers[0].FullName,
                alignment: "left",
                decoration: this.listPassengers[0].OffloadStyle,
              },
              {
                text: this.listPassengers[0].CompanyName,
                decoration: this.listPassengers[0].OffloadStyle,
              },
              {
                text: this.listPassengers[0].Destination,
                decoration: this.listPassengers[0].OffloadStyle,
              },
              this.listPassengers[0].Temp,
              this.listPassengers[0].Alcohol1,
              this.listPassengers[0].Time1,
              this.listPassengers[0].Alcohol2,
              this.listPassengers[0].Time2,
              this.listPassengers[0].OffloadRemark,
            ],
            [
              this.listPassengers[1].No,
              {
                text: this.listPassengers[1].FullName,
                alignment: "left",
                decoration: this.listPassengers[1].OffloadStyle,
              },
              {
                text: this.listPassengers[1].CompanyName,
                decoration: this.listPassengers[1].OffloadStyle,
              },
              {
                text: this.listPassengers[1].Destination,
                decoration: this.listPassengers[1].OffloadStyle,
              },
              this.listPassengers[1].Temp,
              this.listPassengers[1].Alcohol1,
              this.listPassengers[1].Time1,
              this.listPassengers[1].Alcohol2,
              this.listPassengers[1].Time2,
              this.listPassengers[1].OffloadRemark,
            ],
            [
              this.listPassengers[2].No,
              {
                text: this.listPassengers[2].FullName,
                alignment: "left",
                decoration: this.listPassengers[2].OffloadStyle,
              },
              {
                text: this.listPassengers[2].CompanyName,
                decoration: this.listPassengers[2].OffloadStyle,
              },
              {
                text: this.listPassengers[2].Destination,
                decoration: this.listPassengers[2].OffloadStyle,
              },
              this.listPassengers[2].Temp,
              this.listPassengers[2].Alcohol1,
              this.listPassengers[2].Time1,
              this.listPassengers[2].Alcohol2,
              this.listPassengers[2].Time2,
              this.listPassengers[2].OffloadRemark,
            ],
            [
              this.listPassengers[3].No,
              {
                text: this.listPassengers[3].FullName,
                alignment: "left",
                decoration: this.listPassengers[3].OffloadStyle,
              },
              {
                text: this.listPassengers[3].CompanyName,
                decoration: this.listPassengers[3].OffloadStyle,
              },
              {
                text: this.listPassengers[3].Destination,
                decoration: this.listPassengers[3].OffloadStyle,
              },
              this.listPassengers[3].Temp,
              this.listPassengers[3].Alcohol1,
              this.listPassengers[3].Time1,
              this.listPassengers[3].Alcohol2,
              this.listPassengers[3].Time2,
              this.listPassengers[3].OffloadRemark,
            ],
            [
              this.listPassengers[4].No,
              {
                text: this.listPassengers[4].FullName,
                alignment: "left",
                decoration: this.listPassengers[4].OffloadStyle,
              },
              {
                text: this.listPassengers[4].CompanyName,
                decoration: this.listPassengers[4].OffloadStyle,
              },
              {
                text: this.listPassengers[4].Destination,
                decoration: this.listPassengers[4].OffloadStyle,
              },
              this.listPassengers[4].Temp,
              this.listPassengers[4].Alcohol1,
              this.listPassengers[4].Time1,
              this.listPassengers[4].Alcohol2,
              this.listPassengers[4].Time2,
              this.listPassengers[4].OffloadRemark,
            ],
            [
              this.listPassengers[5].No,
              {
                text: this.listPassengers[5].FullName,
                alignment: "left",
                decoration: this.listPassengers[5].OffloadStyle,
              },
              {
                text: this.listPassengers[5].CompanyName,
                decoration: this.listPassengers[5].OffloadStyle,
              },
              {
                text: this.listPassengers[5].Destination,
                decoration: this.listPassengers[5].OffloadStyle,
              },
              this.listPassengers[5].Temp,
              this.listPassengers[5].Alcohol1,
              this.listPassengers[5].Time1,
              this.listPassengers[5].Alcohol2,
              this.listPassengers[5].Time2,
              this.listPassengers[5].OffloadRemark,
            ],
            [
              this.listPassengers[6].No,
              {
                text: this.listPassengers[6].FullName,
                alignment: "left",
                decoration: this.listPassengers[6].OffloadStyle,
              },
              {
                text: this.listPassengers[6].CompanyName,
                decoration: this.listPassengers[6].OffloadStyle,
              },
              {
                text: this.listPassengers[6].Destination,
                decoration: this.listPassengers[6].OffloadStyle,
              },
              this.listPassengers[6].Temp,
              this.listPassengers[6].Alcohol1,
              this.listPassengers[6].Time1,
              this.listPassengers[6].Alcohol2,
              this.listPassengers[6].Time2,
              this.listPassengers[6].OffloadRemark,
            ],
            [
              this.listPassengers[7].No,
              {
                text: this.listPassengers[7].FullName,
                alignment: "left",
                decoration: this.listPassengers[7].OffloadStyle,
              },
              {
                text: this.listPassengers[7].CompanyName,
                decoration: this.listPassengers[7].OffloadStyle,
              },
              {
                text: this.listPassengers[7].Destination,
                decoration: this.listPassengers[7].OffloadStyle,
              },
              this.listPassengers[7].Temp,
              this.listPassengers[7].Alcohol1,
              this.listPassengers[7].Time1,
              this.listPassengers[7].Alcohol2,
              this.listPassengers[7].Time2,
              this.listPassengers[7].OffloadRemark,
            ],
            [
              this.listPassengers[8].No,
              {
                text: this.listPassengers[8].FullName,
                alignment: "left",
                decoration: this.listPassengers[8].OffloadStyle,
              },
              {
                text: this.listPassengers[8].CompanyName,
                decoration: this.listPassengers[8].OffloadStyle,
              },
              {
                text: this.listPassengers[8].Destination,
                decoration: this.listPassengers[8].OffloadStyle,
              },
              this.listPassengers[8].Temp,
              this.listPassengers[8].Alcohol1,
              this.listPassengers[8].Time1,
              this.listPassengers[8].Alcohol2,
              this.listPassengers[8].Time2,
              this.listPassengers[8].OffloadRemark,
            ],
            [
              this.listPassengers[9].No,
              {
                text: this.listPassengers[9].FullName,
                alignment: "left",
                decoration: this.listPassengers[9].OffloadStyle,
              },
              {
                text: this.listPassengers[9].CompanyName,
                decoration: this.listPassengers[9].OffloadStyle,
              },
              {
                text: this.listPassengers[9].Destination,
                decoration: this.listPassengers[9].OffloadStyle,
              },
              this.listPassengers[9].Temp,
              this.listPassengers[9].Alcohol1,
              this.listPassengers[9].Time1,
              this.listPassengers[9].Alcohol2,
              this.listPassengers[9].Time2,
              this.listPassengers[9].OffloadRemark,
            ],
            [
              this.listPassengers[10].No,
              {
                text: this.listPassengers[10].FullName,
                alignment: "left",
                decoration: this.listPassengers[10].OffloadStyle,
              },
              {
                text: this.listPassengers[10].CompanyName,
                decoration: this.listPassengers[10].OffloadStyle,
              },
              {
                text: this.listPassengers[10].Destination,
                decoration: this.listPassengers[10].OffloadStyle,
              },
              this.listPassengers[10].Temp,
              this.listPassengers[10].Alcohol1,
              this.listPassengers[10].Time1,
              this.listPassengers[10].Alcohol2,
              this.listPassengers[10].Time2,
              this.listPassengers[10].OffloadRemark,
            ],
            [
              this.listPassengers[11].No,
              {
                text: this.listPassengers[11].FullName,
                alignment: "left",
                decoration: this.listPassengers[11].OffloadStyle,
              },
              {
                text: this.listPassengers[11].CompanyName,
                decoration: this.listPassengers[11].OffloadStyle,
              },
              {
                text: this.listPassengers[11].Destination,
                decoration: this.listPassengers[11].OffloadStyle,
              },
              this.listPassengers[11].Temp,
              this.listPassengers[11].Alcohol1,
              this.listPassengers[11].Time1,
              this.listPassengers[11].Alcohol2,
              this.listPassengers[11].Time2,
              this.listPassengers[11].OffloadRemark,
            ],
          ],
        };
      }

      var pdfMake = require("../../public/js/pdfmake");
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("../../public/js/vfs_fonts");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      var docDefinition = {
        pageOrientation: "landscape",
        content: [
          {
            style: "tableExample",
            table: {
              headerRows: 1,
              widths: ["*", "auto", "*"],
              body: [
                [
                  {
                    width: uoaimage.w,
                    height: uoaimage.h,
                    alignment: "left",
                    margin: [15, 4, 0, 0],
                    fillColor: "#64B5F6",
                    image: uoaimage.logo,
                  },
                  {
                    text: "The Report Of BAC and Body Temperature Checks",
                    style: "tableHeader",
                    margin: [0, 15, 0, 0],
                    fillColor: "#64B5F6",
                  },
                  {
                    width: customerlogo.w,
                    height: customerlogo.h,
                    alignment: "right",
                    margin: [15, 5, 0, 0],
                    fillColor: "#64B5F6",
                    image: customerlogo.logo,
                  },
                ],
              ],
            },
            layout: "noBorders",
          },

          {
            style: "tableExample2",
            table: {
              headerRows: 1,
              widths: ["*", "auto", "*"],
              body: [
                [
                  {
                    text:
                      "Outbound Passengers from " +
                      this.itemsDataFlight.departairport.ap_name,
                    alignment: "left",
                  },
                  {
                    text: "Flight no : " + this.flightno,
                    alignment: "center",
                  },
                  {
                    text:
                      "Date : " +
                      format(new Date(this.depart_date), "dd/MM/yyy"),
                    alignment: "right",
                  },
                ],
              ],
            },
            layout: "noBorders",
          },
          {
            style: "tableExample",
            table: outboundPassengersFromSKL,
          },
          {
            text: remarkBACReportNo,
            style: "left",
          },
          { text: "Report by " + this.alcoholTestBy, style: "right" },
          { text: documentBACReportNo, style: "right" },
        ],
        styles: {
          header: {
            fontSize: 16,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 10],
          },
          right: {
            alignment: "right",
            margin: [0, 0, 0, 10],
          },
          left: {
            fontSize: 8,
            margin: [0, 0, 0, 10],
          },
          tableExample: {
            fontSize: 10,
            alignment: "center",
            margin: [0, 5, 0, 15],
          },
        },
        defaultStyle: {
          // alignment: 'justify'
        },
      };

      pdfMake.createPdf(docDefinition).download("BAC_Report.pdf");
    },
    async Manifest_Report() {
      await this.SelectListManifest();

      //console.log(JSON.stringify(this.ArrListPassenger_Manifest))

      //Add
      var des = this.itemsDataFlight.arrivalairport.ap_name;
      var Des_Image = await this.$LogoLegService.GetLogoLegBaseurl64(des);
      var NILPassengerImage = await this.$ImagesService.GetNILImage(
        "NILPASSENGER"
      );
      var NILCargoImage = await this.$ImagesService.GetNILImage("NILCARGO");

      var q = {};
      q.retire = "0";
      let listLegs = [];
      var legs = null;
      try {
        var qFlight = {};
        qFlight.f_id = this.idflight;
        qFlight.$eager =
          "[leg.airport,passenger.[baggage,user],flightstatus,terminal,cargo,arrivalairport,departairport]";

        var res = await feathersClientUOA
          .service("flight")
          .find({ query: qFlight });
        legs = res.data[0].CalLegAll;
        // console.log("CalLegAll : " + JSON.stringify(legs))
        this.dataLegsNew = "";
        let c = 0;

        legs.forEach((element) => {
          if (c < legs.length - 1) {
            this.dataLegsNew += element.AirPortName + "-";
          } else {
            this.dataLegsNew += element.AirPortName;
          }
          c++;
        });
      } catch (error) {
        console.log(error);
      }

      let airportLeg = {};
      if (legs != undefined) {
        //จำนวนผู้โดยขาออก
        legs.forEach((element) => {
          if (element.Outbound != null) {
            let outbound = [
              {
                text: element.Outbound,
                style: "center",
                margin: [0, 32, 0, 0],
              },
            ];
            listLegs.push(outbound);
          }
          airportLeg = {};
          airportLeg.width = element.Width * 0.2;
          airportLeg.height = element.Height * 0.2;
          airportLeg.alignment = "center";
          airportLeg.image = element.DataAirport;
          airportLeg.Outbound = element.Outbound;
          airportLeg.Inbound = element.Inbound;
          listLegs.push(airportLeg);

          //จำนวนผู้โดยขาเข้า
          if (element.Inbound != null) {
            let inbound = [
              {
                text: element.Inbound,
                style: "center",
                margin: [0, 32, 0, 0],
              },
            ];
            listLegs.push(inbound);
          }
          //TEST
          // let test = [
          //   {
          //     text: "TEST",
          //     style: "center",
          //     margin: [0, 16, 0, 0],
          //   },
          // ];
          // listLegs.push(test);
          //TEST
        });
      }

      let airportVTSH = {};
      airportVTSH.width = Des_Image.w * 0.5;
      airportVTSH.height = Des_Image.h * 0.5;
      airportVTSH.alignment = "right";
      airportVTSH.image = Des_Image.logo;
      airportVTSH.Outbound = null;
      airportVTSH.Inbound = null;
      listLegs.push(airportVTSH);
      var uoaimage = await this.$LogoService.GetLogoBaseurl64(1);
      var customerlogo = await this.$LogoService.GetLogoBaseurl64(
        this.itemsDataFlight.customer.o_id
      );

      var pdfMake = require("../../public/js/pdfmake");
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("../../public/js/vfs_fonts");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      //Start Check Customer
      let flightRoute = null;
      let flightInformation = null;
      let passengerManifest = null;
      let NILPassenger = null;
      let cargoManifest = null;
      let NILCargo = null;
      let documentNo = "";

      if (this.customer.o_name == "CPOC") {
        //documentNo = "OPS-FM-89 Issue 01 Revision 02";
        //documentNo = "OPS-FM-89 Issue 01 Revision 03";
        documentNo = "OPS-FM-89 Issue 01 Revision 05";
      } else if (this.customer.o_name == "CHOC") {
        //documentNo = "OPS-FM-97 Issue 01 Revision 01";
        //documentNo = "OPS-FM-97 Issue 01 Revision 02";
        documentNo = "OPS-FM-97 Issue 01 Revision 04";
      } else if (this.customer.o_name == "PTT") {
        //documentNo = "OPS-FM-100 Issue 01 Revision 01";
        //documentNo = "OPS-FM-100 Issue 01 Revision 02";
        documentNo = "OPS-FM-100 Issue 01 Revision 03";
      } else if (this.customer.o_name == "MUBADALA") {
        //documentNo = "OPS-FM-102 Issue 01 Revision 01";
        //documentNo = "OPS-FM-102 Issue 01 Revision 02";
        documentNo = "OPS-FM-102 Issue 01 Revision 03";
      } else if (this.customer.o_name == "UOA") {
        documentNo = "OPS-FM-09 Issue 01 Revision 03";
      }

      // REVISE ZONE START
      // //Duplicates
      // let listReviseNo = [];
      // res.data.forEach((element) => {
      //   listReviseNo.push(element.bh_revise_no);
      // });
      // let reviseNos = [...new Set(listReviseNo)];

      let qRevise = {};
      qRevise.f_id = this.idflight;
      qRevise.$sort = {
        bh_revise_no: 1,
      };
      let resRevise = await feathersClientUOA
        .service("onbehalf")
        .find({ query: qRevise });
      let onbehalf = resRevise.data;

      let action1 = null;
      let action3 = null;
      let action4 = null;
      let action5 = null;
      if (resRevise.total > 0) {
        let no = onbehalf.sort((a, b) => b.bh_revise_no - a.bh_revise_no)[0]
          .bh_revise_no;
        this.reviseNo = "Revise : " + no;
        //แยก case
        if (onbehalf.filter((x) => x.bha_id == 1).length > 0) {
          //bh_revise_no มากไปน้อย และเอาตัวแรกสุด
          action1 = onbehalf
            .filter((x) => x.bha_id == 1)
            .sort((a, b) => b.bh_revise_no - a.bh_revise_no)[0];
        }
        //case 2 ไม่มีใน MNF
        if (onbehalf.filter((x) => x.bha_id == 3).length > 0) {
          action3 = onbehalf
            .filter((x) => x.bha_id == 3)
            .sort((a, b) => b.bh_revise_no - a.bh_revise_no)[0];
        }

        if (onbehalf.filter((x) => x.bha_id == 4).length > 0) {
          action4 = onbehalf
            .filter((x) => x.bha_id == 4)
            .sort((a, b) => b.bh_revise_no - a.bh_revise_no)[0];
        }

        if (onbehalf.filter((x) => x.bha_id == 5).length > 0) {
          action5 = onbehalf
            .filter((x) => x.bha_id == 5)
            .sort((a, b) => b.bh_revise_no - a.bh_revise_no)[0];
        }
      }
      // REVISE ZONE END

      //Start Flight Information CPOC UOA PTT MUBADALA
      let previousDepartTime = "";
      let decorationDepartTimeStyle = "";
      let currentDapartTime = "";
      if (action1 != null) {
        previousDepartTime = action1.bh_previous_data.substring(11, 16);
        decorationDepartTimeStyle = "lineThrough";
        currentDapartTime = action1.bh_current_data.substring(11, 16);
      } else {
        previousDepartTime = this.depart_time;
        decorationDepartTimeStyle = "";
        currentDapartTime = "";
      }

      let previousAircraft = "";
      let decorationAircraftStyle = "";
      let currentAircraft = "";
      if (action3 != null) {
        previousAircraft = action3.bh_previous_data;
        decorationAircraftStyle = "lineThrough";
        currentAircraft = action3.bh_current_data;
      } else {
        previousAircraft = this.aircarftName;
        decorationAircraftStyle = "";
        currentAircraft = "";
      }

      flightInformation = {
        //widths: [70, 170],
        //widths: [70, 35, 135],
        widths: [70, 50, 50, 50],
        body: [
          [
            { text: "DATE  : ", border: [true, true, false, false] },
            {
              text: format(addHours(new Date(this.itemsDataFlight.ap_depart_date),-7),"dd MMM yy"),
              border: [false, true, true, false],
              color: "red",
              colSpan: 3,
            },
            "",
            "",
            // { text: "", border: [false, true, false, false] },
            // { text: "", border: [false, true, true, false] },
          ],
          [
            {
              text: "FLIGHT NO :",
              border: [true, false, false, false],
            },
            {
              text: this.flightno,
              border: [false, false, true, false],
              color: "red",
              colSpan: 3,
            },
            "",
            "",
            // { text: "", border: [false, false, false, false] },
            // { text: "", border: [false, false, true, false] },
          ],
          [
            {
              text: "AIRCRAFT :",
              border: [true, false, false, false],
            },
            {
              text: previousAircraft,
              border: [false, false, false, false],
              color: "red",
              decoration: decorationAircraftStyle,
            },
            {
              text: currentAircraft,
              border: [false, false, true, false],
              color: "red",
              colSpan: 2,
            },
            "",
            // { text: "", border: [false, false, true, false] },
          ],
          [
            { text: "ETD : ", border: [true, false, false, true] },
            {
              text: previousDepartTime,
              border: [false, false, false, true],
              color: "red",
              decoration: decorationDepartTimeStyle,
            },
            {
              text: currentDapartTime,
              border: [false, false, true, true],
              color: "red",
              colSpan: 2,
            },
            "",
            // { text: "", border: [false, false, true, true] },
          ],
        ],
      };
      //End Flight Information CPOC UOA PTT MUBADALA

      if (
        this.customer.o_name == "CPOC" ||
        this.customer.o_name == "CHOC" ||
        this.customer.o_name == "UOA"
      ) {
        //Start Flight Route CPOC UOA Show Revise PILOT & CO-PILOT
        flightRoute = {
          widths: [39, 21, 11, 149],
          body: [
            [
              { text: "FROM :", border: [true, true, false, false] },
              {
                text: this.itemsDataFlight.departairport.ap_name,
                border: [false, true, false, false],
                color: "red",
              },
              { text: "TO", border: [false, true, false, false] },
              {
                text: this.dataLegsNew,
                //ext: legs,
                border: [false, true, true, false],
                color: "red",
              },
            ],
            [
              { text: "PILOT :", border: [true, false, false, false] },
              {
                text: this.pilot,
                border: [false, false, true, false],
                color: "red",
                colSpan: 3,
              },
              "",
              "",
            ],
            [
              {
                text: "CO-PILOT :",
                border: [true, false, false, false],
              },
              {
                text: this.copilot,
                border: [false, false, true, false],
                colSpan: 3,
                color: "red",
              },
              "",
              "",
            ],
            [
              {
                text: " ",
                border: [true, false, true, true],
                colSpan: 4,
              },
              "",
              "",
              "",
            ],
          ],
        };
        //End Flight Route

        //Start Passenger Manifest CPOC, CHOC, UOA
        passengerManifest = {
          style: "tableOutBound",
          table: {
            // widths: [15, 95, 90, 60, 38, 35, 38, 35, 30],
            // widths: [10, 95, 77, 12, 75, 38, 35, 38, 35, 30],
            widths: [10, 95, 59, 12, 75, 29, 32, 29, 32, 47,17.1],
            body: [
              [
                { text: "No.", rowSpan: 2 },
                {
                  text: "Passenger",
                  alignment: "center",
                  rowSpan: 2,
                  colSpan: 2,
                  border: [false, true, false, false],
                },
                { text: "", border: [false, true, false, false] },
                { text: "Seat", rowSpan: 2 },
                {
                  text: "Company",
                  rowSpan: 2,
                  border: [true, true, false, false],
                  alignment: "center",
                },
                { text: "Weight(Kg.)", colSpan: 2 },
                { text: "" },
                { text: "Weight(Lbs.)", colSpan: 2 },
                { text: "" },
                { text: "Total of Luggage.", rowSpan: 2 },
                { text: "Dest.", rowSpan: 2 },
              ],
              [
                { text: "" },
                { text: "" },
                { text: "", rolSpan: 2, border: [false, false, true, false] },
                { text: "", rolSpan: 2, border: [false, false, true, false] },
                { text: "" },
                { text: "Passenger" },
                { text: "Luggage" },
                { text: "Passenger" },
                { text: "Luggage" },
                { text: "" },
                { text: "" },
              ],
              [
                { text: this.listPassengers_Manifest[0].No },
                {
                  text: this.listPassengers_Manifest[0].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[0].FullNameColor,
                  decoration: this.listPassengers_Manifest[0].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[0].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[0].SeatNo },
                {
                  text: this.listPassengers_Manifest[0].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[0].Style,
                },
                {
                  text: this.listPassengers_Manifest[0].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[0].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[0].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[0].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[0].WeightBody_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[0].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[0].WeightBaggage_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[0].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[0].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[0].Style,
                },
                {
                  text: this.listPassengers_Manifest[0].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[0].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[1].No },
                {
                  text: this.listPassengers_Manifest[1].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[1].FullNameColor,
                  decoration: this.listPassengers_Manifest[1].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[1].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[1].SeatNo },
                {
                  text: this.listPassengers_Manifest[1].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[1].Style,
                },
                {
                  text: this.listPassengers_Manifest[1].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[1].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[1].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[1].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[1].WeightBody_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[1].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[1].WeightBaggage_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[1].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[1].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[1].Style,
                },
                {
                  text: this.listPassengers_Manifest[1].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[1].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[2].No },
                {
                  text: this.listPassengers_Manifest[2].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[2].FullNameColor,
                  decoration: this.listPassengers_Manifest[2].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[2].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[2].SeatNo },
                {
                  text: this.listPassengers_Manifest[2].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[2].Style,
                },
                {
                  text: this.listPassengers_Manifest[2].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[2].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[2].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[2].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[2].WeightBody_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[2].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[2].WeightBaggage_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[2].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[2].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[2].Style,
                },
                {
                  text: this.listPassengers_Manifest[2].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[2].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[3].No },
                {
                  text: this.listPassengers_Manifest[3].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[3].FullNameColor,
                  decoration: this.listPassengers_Manifest[3].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[3].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[3].SeatNo },
                {
                  text: this.listPassengers_Manifest[3].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[3].Style,
                },
                {
                  text: this.listPassengers_Manifest[3].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[3].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[3].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[3].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[3].WeightBody_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[3].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[3].WeightBaggage_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[3].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[3].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[3].Style,
                },
                {
                  text: this.listPassengers_Manifest[3].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[3].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[4].No },
                {
                  text: this.listPassengers_Manifest[4].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[4].FullNameColor,
                  decoration: this.listPassengers_Manifest[4].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[4].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[4].SeatNo },
                {
                  text: this.listPassengers_Manifest[4].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[4].Style,
                },
                {
                  text: this.listPassengers_Manifest[4].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[4].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[4].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[4].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[4].WeightBody_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[4].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[4].WeightBaggage_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[4].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[4].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[4].Style,
                },
                {
                  text: this.listPassengers_Manifest[4].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[4].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[5].No },
                {
                  text: this.listPassengers_Manifest[5].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[5].FullNameColor,
                  decoration: this.listPassengers_Manifest[5].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[5].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[5].SeatNo },
                {
                  text: this.listPassengers_Manifest[5].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[5].Style,
                },
                {
                  text: this.listPassengers_Manifest[5].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[5].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[5].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[5].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[5].WeightBody_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[5].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[5].WeightBaggage_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[5].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[5].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[5].Style,
                },
                {
                  text: this.listPassengers_Manifest[5].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[5].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[6].No },
                {
                  text: this.listPassengers_Manifest[6].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[6].FullNameColor,
                  decoration: this.listPassengers_Manifest[6].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[6].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[6].SeatNo },
                {
                  text: this.listPassengers_Manifest[6].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[6].Style,
                },
                {
                  text: this.listPassengers_Manifest[6].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[6].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[6].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[6].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[6].WeightBody_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[6].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[6].WeightBaggage_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[6].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[6].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[6].Style,
                },
                {
                  text: this.listPassengers_Manifest[6].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[6].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[7].No },
                {
                  text: this.listPassengers_Manifest[7].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[7].FullNameColor,
                  decoration: this.listPassengers_Manifest[7].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[7].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[7].SeatNo },
                {
                  text: this.listPassengers_Manifest[7].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[7].Style,
                },
                {
                  text: this.listPassengers_Manifest[7].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[7].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[7].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[7].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[7].WeightBody_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[7].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[7].WeightBaggage_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[7].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[7].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[7].Style,
                },
                {
                  text: this.listPassengers_Manifest[7].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[7].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[8].No },
                {
                  text: this.listPassengers_Manifest[8].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[8].FullNameColor,
                  decoration: this.listPassengers_Manifest[8].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[8].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[8].SeatNo },
                {
                  text: this.listPassengers_Manifest[8].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[8].Style,
                },
                {
                  text: this.listPassengers_Manifest[8].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[8].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[8].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[8].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[8].WeightBody_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[8].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[8].WeightBaggage_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[8].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[8].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[8].Style,
                },
                {
                  text: this.listPassengers_Manifest[8].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[8].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[9].No },
                {
                  text: this.listPassengers_Manifest[9].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[9].FullNameColor,
                  decoration: this.listPassengers_Manifest[9].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[9].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[9].SeatNo },
                {
                  text: this.listPassengers_Manifest[9].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[9].Style,
                },
                {
                  text: this.listPassengers_Manifest[9].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[9].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[9].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[9].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[9].WeightBody_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[9].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[9].WeightBaggage_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[9].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[9].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[9].Style,
                },
                {
                  text: this.listPassengers_Manifest[9].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[9].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[10].No },
                {
                  text: this.listPassengers_Manifest[10].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[10].FullNameColor,
                  decoration: this.listPassengers_Manifest[10].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[10].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[10].SeatNo },
                {
                  text: this.listPassengers_Manifest[10].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[10].Style,
                },
                {
                  text: this.listPassengers_Manifest[10].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[10].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[10].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[10].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[10].WeightBody_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[10].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[10].WeightBaggage_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[10].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[10].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[10].Style,
                },
                {
                  text: this.listPassengers_Manifest[10].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[10].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[11].No },
                {
                  text: this.listPassengers_Manifest[11].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[11].FullNameColor,
                  decoration: this.listPassengers_Manifest[11].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[11].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[11].SeatNo },
                {
                  text: this.listPassengers_Manifest[11].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[11].Style,
                },
                {
                  text: this.listPassengers_Manifest[11].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[11].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[11].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[11].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[11].WeightBody_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[11].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[11].WeightBaggage_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[11].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[11].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[11].Style,
                },
                {
                  text: this.listPassengers_Manifest[11].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[11].Style,
                },
              ],
              //Add 13 - 14
              [
                { text: this.listPassengers_Manifest[12].No },
                {
                  text: this.listPassengers_Manifest[12].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[12].FullNameColor,
                  decoration: this.listPassengers_Manifest[12].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[12].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[12].SeatNo },
                {
                  text: this.listPassengers_Manifest[12].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[12].Style,
                },
                {
                  text: this.listPassengers_Manifest[12].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[12].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[12].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[12].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[12].WeightBody_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[12].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[12].WeightBaggage_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[12].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[12].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[12].Style,
                },
                {
                  text: this.listPassengers_Manifest[12].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[12].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[13].No },
                {
                  text: this.listPassengers_Manifest[13].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[13].FullNameColor,
                  decoration: this.listPassengers_Manifest[13].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[13].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[13].SeatNo },
                {
                  text: this.listPassengers_Manifest[13].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[13].Style,
                },
                {
                  text: this.listPassengers_Manifest[13].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[13].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[13].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[13].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[13].WeightBody_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[13].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[13].WeightBaggage_Lbs,
                  color: "#1A1EE6",
                  decoration: this.listPassengers_Manifest[13].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[13].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[13].Style,
                },
                {
                  text: this.listPassengers_Manifest[13].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[13].Style,
                },
              ],
              [
                {
                  text: "",
                  colSpan: 3,
                  border: [false, false, false, false],
                },
                { text: "" },
                { text: "" },
                { text: "", border: [false, false, false, false] },
                {
                  text: "TOTAL",
                  border: [false, false, true, false],
                  alignment: "right",
                },
                {
                  text: this.totalBody_KG_Out,
                  color: "#EC37E9",
                  fontSize: 10,
                  bold: true,
                },
                {
                  text: this.totalBaggage_KG_Out,
                  color: "#EC37E9",
                  fontSize: 10,
                  bold: true,
                },
                {
                  text: this.totalBody_LBS_Out,
                  color: "#1A1EE6",
                  fontSize: 10,
                  bold: true,
                },
                {
                  text: this.totalBaggage_LBS_Out,
                  color: "#1A1EE6",
                  fontSize: 10,
                  bold: true,
                },
                {
                  text: this.sumTotalBaggage_Out,
                  color: "#FF2D00",
                  fontSize: 10,
                  bold: true,
                },
                { text: "", border: [false, false, false, false] },
              ],
              [
                { text: "", border: [false, false, false, false] },
                {
                  style: "tableTotalPax",
                  table: {
                    body: [
                      [
                        {
                          text: "TOTAL",
                          border: [false, false, false, false],
                        },
                        {
                          text: this.totalPax,
                          color: "red",
                          decoration: "underline",
                          border: [false, false, false, false],
                        },
                        { text: "PAX", border: [false, false, false, false] },
                      ],
                    ],
                  },
                  layout: "noBorders",
                  border: [false, false, false, false],
                  alignment: "center",
                  margin: [30, 0, 0, 0],
                  colSpan: 2,
                },
                { text: "" },
                { text: "", border: [false, false, false, false] },
                {
                  text: "GRAND TOTAL",
                  border: [false, false, true, false],
                  alignment: "right",
                },
                {
                  text: this.sumtotal_KG_Out.toFixed(0),
                  color: "#EC37E9",
                  colSpan: 2,
                  fontSize: 10,
                  bold: true,
                },
                { text: "" },
                {
                  text: this.sumtotal_LBS_Out.toFixed(0),
                  color: "#1A1EE6",
                  colSpan: 2,
                  fontSize: 10,
                  bold: true,
                },
                { text: "" },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
        };
        //End Passenger Manifest

        //Start Cargo Manifest CPOC CHOC UOA
        cargoManifest = {
          style: "tableOutCargo",
          table: {
            widths: [10, 40, 180, 68, 32, 70, 47, 17.1],
            body: [
              [
                { text: "No." },
                { text: "DAN No." },
                { text: "Description" },
                { text: "Consigned To" },
                { text: "Weight(Kg.)" },
                { text: "Weight(Lbs.)" },
                { text: "Total (PCS)" },
                { text: "Dest." },
              ],
              [
                { text: this.listCargos_Manifest[0].No },
                {
                  text: this.listCargos_Manifest[0].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[0].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[0].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[0].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[0].LbsWeight,
                  color: "#1A1EE6",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[0].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[0].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[1].No },
                {
                  text: this.listCargos_Manifest[1].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[1].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[1].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[1].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[1].LbsWeight,
                  color: "#1A1EE6",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[1].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[1].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[2].No },
                {
                  text: this.listCargos_Manifest[2].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[2].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[2].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[2].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[2].LbsWeight,
                  color: "#1A1EE6",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[2].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[2].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[3].No },
                {
                  text: this.listCargos_Manifest[3].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[3].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[3].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[3].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[3].LbsWeight,
                  color: "#1A1EE6",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[3].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[3].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[4].No },
                {
                  text: this.listCargos_Manifest[4].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[4].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[4].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[4].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[4].LbsWeight,
                  color: "#1A1EE6",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[4].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[4].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[5].No },
                {
                  text: this.listCargos_Manifest[5].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[5].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[5].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[5].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[5].LbsWeight,
                  color: "#1A1EE6",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[5].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[5].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[6].No },
                {
                  text: this.listCargos_Manifest[6].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[6].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[6].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[6].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[6].LbsWeight,
                  color: "#1A1EE6",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[6].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[6].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[7].No },
                {
                  text: this.listCargos_Manifest[7].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[7].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[7].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[7].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[7].LbsWeight,
                  color: "#1A1EE6",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[7].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[7].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[8].No },
                {
                  text: this.listCargos_Manifest[8].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[8].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[8].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[8].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[8].LbsWeight,
                  color: "#1A1EE6",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[8].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[8].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[9].No },
                {
                  text: this.listCargos_Manifest[9].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[9].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[9].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[9].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[9].LbsWeight,
                  color: "#1A1EE6",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[9].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[9].Destination,
                  color: "#3F3395",
                },
              ],
              [
                {
                  image:
                    "data:image/jpeg;base64,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",
                  // width: 170,
                  // height: 40,
                  width: 250,
                  //height: 40,
                  alignment: "left",
                  colSpan: 3,
                  rowSpan: 5,
                  border: [false, false, false, false],
                  margin: [10, 0, 0, 0],
                },
                { text: "", rowSpan: 3 },
                { text: "", rowSpan: 3 },
                {
                  text: "TOTAL",
                  border: [false, false, true, false],
                  alignment: "right",
                },
                {
                  text: this.totalCargo_KG.toFixed(0),
                  color: "#EC37E9",
                  fontSize: 10,
                  bold: true,
                },
                {
                  text: this.totalCargo_LBS.toFixed(0),
                  color: "#1A1EE6",
                  fontSize: 10,
                  bold: true,
                },
                {
                  text: this.totalCargo_amount,
                  color:  "#FF2D00",
                  fontSize: 10,
                  bold: true,
                },
                { text: "", border: [false, false, false, false] },
              ],
              [
                { text: "" },
                { text: "", rowSpan: 3 },
                { text: "", rowSpan: 3 },
                { text: "\n", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
              [
                {
                  text: "",
                  colSpan: 3,
                  border: [false, false, false, false],
                },
                { text: "" },
                { text: "" },
                {
                  text: "GRAND TOTAL",
                  border: [false, false, true, false],
                  alignment: "right",
                },
                {
                  text: (this.sumtotal_KG_Out + this.totalCargo_KG).toFixed(0),
                  color: "#EC37E9",
                  fontSize: 10,
                  bold: true,
                },
                {
                  text: (this.sumtotal_LBS_Out + this.totalCargo_LBS).toFixed(
                    0
                  ),
                  color: "#1A1EE6",
                  fontSize: 10,
                  bold: true,
                },
                {
                  text: this.sumTotalBaggage_Out + this.totalCargo_amount,
                  color: "#FF2D00",
                  fontSize: 10,
                  bold: true,
                },
                { text: "", border: [false, false, false, false] },
              ],
              [
                { text: "" },
                { text: "", rowSpan: 3 },
                { text: "", rowSpan: 3 },
                { text: "\n", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
              [
                {
                  text: "",
                  colSpan: 3,
                  border: [false, false, false, false],
                },
                { text: "" },
                { text: "" },
                {
                  text: "AVAILABLE PAYLOAD",
                  border: [false, false, true, false],
                  alignment: "right",
                },
                {
                  text: this.available_payload,
                  color: "#EC37E9",
                  fontSize: 10,
                  bold: true,
                },
                {
                  text: this.available_payloadLbs,
                  color: "#1A1EE6",
                  fontSize: 10,
                  bold: true,
                },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
              [
                {
                  text: "",
                  colSpan: 3,
                  border: [false, false, false, false],
                },
                { text: "" },
                { text: "" },
                {
                  text: "",
                  border: [false, false, false, false],
                  alignment: "right",
                },
                {
                  text: "",
                  color: "#EC37E9",
                  border: [false, false, false, false],
                  fontSize: 10,
                },
                {
                  text: "",
                  color: "#1A1EE6",
                  border: [false, false, false, false],
                  fontSize: 10,
                },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
        };
        //End Cargo Manifest
      } else if (
        this.customer.o_name == "PTT" ||
        this.customer.o_name == "MUBADALA"
      ) {
        //Start Flight Route PTT & MUBADALA NOT SHOW REVISE PILOT % CO-PILOT
        flightRoute = {
          widths: [39, 21, 11, 149],
          body: [
            [
              { text: "FROM :", border: [true, true, false, false] },
              {
                text: this.itemsDataFlight.departairport.ap_name,
                border: [false, true, false, false],
                color: "red",
              },
              { text: "TO", border: [false, true, false, false] },
              {
                text: this.dataLegsNew,
                //ext: legs,
                border: [false, true, true, false],
                color: "red",
              },
            ],
            [
              {
                text: " ",
                border: [true, false, true, false],
                colSpan: 4,
              },
              "",
              "",
              "",
            ],
            [
              {
                text: " ",
                border: [true, false, true, false],
                colSpan: 4,
              },
              "",
              "",
              "",
            ],
            [
              {
                text: " ",
                border: [true, false, true, true],
                colSpan: 4,
              },
              "",
              "",
              "",
            ],
          ],
        };
        //End Flight Route

        //Start Passenger Manifest PTT, MUBADALA
        passengerManifest = {
          style: "tableOutBound",
          table: {
            widths: [10, 95, 115, 12, 73, 32, 32, 40, 50],
            body: [
              [
                { text: "No.", rowSpan: 2 },
                {
                  text: "Passenger",
                  alignment: "center",
                  rowSpan: 2,
                  colSpan: 2,
                  border: [false, true, false, false],
                },
                { text: "", border: [false, true, false, false] },
                {
                  text: "Seat",
                  rowSpan: 2,
                  border: [true, true, false, false],
                },
                {
                  text: "Company",
                  rowSpan: 2,
                  border: [true, true, false, false],
                },
                { text: "Weight(Kg.)", colSpan: 2 },
                { text: "" },
                { text: "Total of Luggage", rowSpan: 2 },
                { text: "Dest.", rowSpan: 2 },
              ],
              [
                { text: "" },
                { text: "" },
                { text: "", rolSpan: 2, border: [false, false, true, false] },
                { text: "", rolSpan: 2, border: [false, false, true, false] },
                { text: "" },
                { text: "Passenger" },
                { text: "Luggage" },
                { text: "" },
                { text: "" },
              ],
              [
                { text: this.listPassengers_Manifest[0].No },
                {
                  text: this.listPassengers_Manifest[0].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[0].FullNameColor,
                  decoration: this.listPassengers_Manifest[0].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[0].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[0].SeatNo },
                {
                  text: this.listPassengers_Manifest[0].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[0].Style,
                },
                {
                  text: this.listPassengers_Manifest[0].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[0].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[0].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[0].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[0].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[0].Style,
                },
                {
                  text: this.listPassengers_Manifest[0].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[0].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[1].No },
                {
                  text: this.listPassengers_Manifest[1].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[1].FullNameColor,
                  decoration: this.listPassengers_Manifest[1].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[1].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[1].SeatNo },
                {
                  text: this.listPassengers_Manifest[1].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[1].Style,
                },
                {
                  text: this.listPassengers_Manifest[1].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[1].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[1].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[1].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[1].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[1].Style,
                },  
                {
                  text: this.listPassengers_Manifest[1].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[1].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[2].No },
                {
                  text: this.listPassengers_Manifest[2].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[2].FullNameColor,
                  decoration: this.listPassengers_Manifest[2].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[2].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[2].SeatNo },
                {
                  text: this.listPassengers_Manifest[2].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[2].Style,
                },
                {
                  text: this.listPassengers_Manifest[2].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[2].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[2].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[2].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[2].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[2].Style,
                },
                {
                  text: this.listPassengers_Manifest[2].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[2].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[3].No },
                {
                  text: this.listPassengers_Manifest[3].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[3].FullNameColor,
                  decoration: this.listPassengers_Manifest[3].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[3].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[3].SeatNo },
                {
                  text: this.listPassengers_Manifest[3].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[3].Style,
                },
                {
                  text: this.listPassengers_Manifest[3].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[3].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[3].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[3].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[3].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[3].Style,
                },
                {
                  text: this.listPassengers_Manifest[3].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[3].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[4].No },
                {
                  text: this.listPassengers_Manifest[4].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[4].FullNameColor,
                  decoration: this.listPassengers_Manifest[4].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[4].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[4].SeatNo },
                {
                  text: this.listPassengers_Manifest[4].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[4].Style,
                },
                {
                  text: this.listPassengers_Manifest[4].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[4].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[4].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[4].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[4].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[4].Style,
                },
                {
                  text: this.listPassengers_Manifest[4].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[4].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[5].No },
                {
                  text: this.listPassengers_Manifest[5].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[5].FullNameColor,
                  decoration: this.listPassengers_Manifest[5].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[5].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[5].SeatNo },
                {
                  text: this.listPassengers_Manifest[5].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[5].Style,
                },
                {
                  text: this.listPassengers_Manifest[5].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[5].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[5].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[5].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[5].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[5].Style,
                },
                {
                  text: this.listPassengers_Manifest[5].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[5].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[6].No },
                {
                  text: this.listPassengers_Manifest[6].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[6].FullNameColor,
                  decoration: this.listPassengers_Manifest[6].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[6].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[6].SeatNo },
                {
                  text: this.listPassengers_Manifest[6].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[6].Style,
                },
                {
                  text: this.listPassengers_Manifest[6].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[6].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[6].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[6].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[6].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[6].Style,
                },
                {
                  text: this.listPassengers_Manifest[6].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[6].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[7].No },
                {
                  text: this.listPassengers_Manifest[7].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[7].FullNameColor,
                  decoration: this.listPassengers_Manifest[7].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[7].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[7].SeatNo },
                {
                  text: this.listPassengers_Manifest[7].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[7].Style,
                },
                {
                  text: this.listPassengers_Manifest[7].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[7].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[7].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[7].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[7].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[7].Style,
                },
                {
                  text: this.listPassengers_Manifest[7].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[7].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[8].No },
                {
                  text: this.listPassengers_Manifest[8].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[8].FullNameColor,
                  decoration: this.listPassengers_Manifest[8].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[8].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[8].SeatNo },
                {
                  text: this.listPassengers_Manifest[8].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[8].Style,
                },
                {
                  text: this.listPassengers_Manifest[8].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[8].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[8].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[8].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[8].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[8].Style,
                },
                {
                  text: this.listPassengers_Manifest[8].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[8].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[9].No },
                {
                  text: this.listPassengers_Manifest[9].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[9].FullNameColor,
                  decoration: this.listPassengers_Manifest[9].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[9].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[9].SeatNo },
                {
                  text: this.listPassengers_Manifest[9].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[9].Style,
                },
                {
                  text: this.listPassengers_Manifest[9].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[9].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[9].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[9].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[9].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[9].Style,
                },
                {
                  text: this.listPassengers_Manifest[9].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[9].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[10].No },
                {
                  text: this.listPassengers_Manifest[10].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[10].FullNameColor,
                  decoration: this.listPassengers_Manifest[10].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[10].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[10].SeatNo },
                {
                  text: this.listPassengers_Manifest[10].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[10].Style,
                },
                {
                  text: this.listPassengers_Manifest[10].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[10].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[10].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[10].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[10].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[10].Style,
                },
                {
                  text: this.listPassengers_Manifest[10].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[10].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[11].No },
                {
                  text: this.listPassengers_Manifest[11].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[11].FullNameColor,
                  decoration: this.listPassengers_Manifest[11].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[11].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[11].SeatNo },
                {
                  text: this.listPassengers_Manifest[11].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[11].Style,
                },
                {
                  text: this.listPassengers_Manifest[11].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[11].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[11].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[11].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[11].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[11].Style,
                },
                {
                  text: this.listPassengers_Manifest[11].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[11].Style,
                },
              ],
              //Add 13 - 14
              [
                { text: this.listPassengers_Manifest[12].No },
                {
                  text: this.listPassengers_Manifest[12].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[12].FullNameColor,
                  decoration: this.listPassengers_Manifest[12].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[12].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[12].SeatNo },
                {
                  text: this.listPassengers_Manifest[12].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[12].Style,
                },
                {
                  text: this.listPassengers_Manifest[12].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[12].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[12].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[12].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[12].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[12].Style,
                },
                {
                  text: this.listPassengers_Manifest[12].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[12].Style,
                },
              ],
              [
                { text: this.listPassengers_Manifest[13].No },
                {
                  text: this.listPassengers_Manifest[13].FullName,
                  alignment: "left",
                  color: this.listPassengers_Manifest[13].FullNameColor,
                  decoration: this.listPassengers_Manifest[13].Style,
                  border: [true, true, false, true],
                },
                {
                  text: this.listPassengers_Manifest[13].Offload_Name,
                  alignment: "left",
                  color: "red",
                  border: [false, true, true, true],
                },
                { text: this.listPassengers_Manifest[13].SeatNo },
                {
                  text: this.listPassengers_Manifest[13].CompanyName,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[13].Style,
                },
                {
                  text: this.listPassengers_Manifest[13].WeightBody_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[13].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[13].WeightBaggage_Kg,
                  color: "#EC37E9",
                  decoration: this.listPassengers_Manifest[13].Style,
                  bold: true,
                },
                {
                  text: this.listPassengers_Manifest[13].Baggage_total,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[13].Style,
                },
                {
                  text: this.listPassengers_Manifest[13].Destination,
                  color: "#3F3395",
                  decoration: this.listPassengers_Manifest[13].Style,
                },
              ],
              [
                {
                  text: "",
                  colSpan: 3,
                  border: [false, false, false, false],
                },
                { text: "" },
                { text: "" },
                { text: "", border: [false, false, false, false] },
                {
                  text: "TOTAL",
                  border: [false, false, true, false],
                  alignment: "right",
                },
                {
                  text: this.totalBody_KG_Out,
                  color: "#EC37E9",
                  fontSize: 10,
                  bold: true,
                },
                {
                  text: this.totalBaggage_KG_Out,
                  color: "#EC37E9",
                  fontSize: 10,
                  bold: true,
                },
                {
                  text: this.sumTotalBaggage_Out,
                  color: "#FF2D00",
                  fontSize: 10,
                  bold: true,
                },
                {
                  text: "",
                  border: [false, false, false, false],
                  bold: true,
                  alignment: "left",
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                {
                  style: "tableTotalPax",
                  table: {
                    body: [
                      [
                        {
                          text: "TOTAL",
                          border: [false, false, false, false],
                        },
                        {
                          text: this.totalPax,
                          color: "red",
                          decoration: "underline",
                          border: [false, false, false, false],
                        },
                        { text: "PAX", border: [false, false, false, false] },
                      ],
                    ],
                  },
                  layout: "noBorders",
                  border: [false, false, false, false],
                  alignment: "center",
                  margin: [30, 0, 0, 0],
                  colSpan: 2,
                },
                {
                  text: "",
                  border: [false, false, false, false],
                  bold: true,
                  alignment: "left",
                },
                {
                  text: "",
                  border: [false, false, false, false],
                },
                {
                  text: "GRAND TOTAL",
                  border: [false, false, true, false],
                  alignment: "right",
                },
                {
                  text: this.sumtotal_KG_Out.toFixed(0),
                  color: "#EC37E9",
                  colSpan: 2,
                  fontSize: 10,
                  bold: true,
                },
                { text: "" },
                {
                  text: "Kg.",
                  border: [false, false, false, false],
                  bold: true,
                  alignment: "left",
                },
                {
                  text: "",
                  border: [false, false, false, false],
                  bold: true,
                  alignment: "left",
                },
              ],
            ],
          },
        };
        //End Passenger Manifest

        //Start Cargo Manifest PPT & MUBADALA
        cargoManifest = {
          style: "tableOutCargo",
          table: {
            widths: [10, 65, 180, 100, 32, 40, 50],
            body: [
              [
                { text: "No." },
                { text: "DAN No." },
                { text: "Description" },
                { text: "Consigned To" },
                { text: "Weight(Kg.)" },
                { text: "Total (PCS)" },
                { text: "Dest." },
              ],
              [
                { text: this.listCargos_Manifest[0].No },
                {
                  text: this.listCargos_Manifest[0].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[0].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[0].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[0].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[0].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[0].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[1].No },
                {
                  text: this.listCargos_Manifest[1].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[1].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[1].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[1].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[1].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[1].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[2].No },
                {
                  text: this.listCargos_Manifest[2].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[2].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[2].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[2].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[2].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[2].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[3].No },
                {
                  text: this.listCargos_Manifest[3].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[3].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[3].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[3].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[3].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[3].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[4].No },
                {
                  text: this.listCargos_Manifest[4].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[4].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[4].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[4].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[4].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[4].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[5].No },
                {
                  text: this.listCargos_Manifest[5].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[5].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[5].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[5].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[5].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[5].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[6].No },
                {
                  text: this.listCargos_Manifest[6].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[6].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[6].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[6].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[6].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[6].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[7].No },
                {
                  text: this.listCargos_Manifest[7].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[7].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[7].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[7].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[7].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[7].Destination,
                  color: "#3F3395",
                },              ],
              [
                { text: this.listCargos_Manifest[8].No },
                {
                  text: this.listCargos_Manifest[8].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[8].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[8].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[8].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[8].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[8].Destination,
                  color: "#3F3395",
                },
              ],
              [
                { text: this.listCargos_Manifest[9].No },
                {
                  text: this.listCargos_Manifest[9].DANNo,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[9].Description,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[9].Consigned,
                  alignment: "center",
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[9].KgWeight,
                  color: "#EC37E9",
                  bold: true,
                },
                {
                  text: this.listCargos_Manifest[9].Amount,
                  color: "#3F3395",
                },
                {
                  text: this.listCargos_Manifest[9].Destination,
                  color: "#3F3395",
                },
              ],
              [
                {
                  image:
                    "data:image/jpeg;base64,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",
                  // width: 170,
                  // height: 40,
                  width: 250,
                  //height: 40,
                  alignment: "left",
                  colSpan: 3,
                  rowSpan: 5,
                  border: [false, false, false, false],
                  margin: [10, 0, 0, 0],
                },
                { text: "", rowSpan: 3 },
                { text: "", rowSpan: 3 },
                {
                  text: "TOTAL",
                  border: [false, false, true, false],
                  alignment: "right",
                },
                {
                  text: this.totalCargo_KG.toFixed(0),
                  color: "#EC37E9",
                  fontSize: 10,
                  bold: true,
                },
                {
                  text: this.totalCargo_amount,
                  color:  "#FF2D00",
                  fontSize: 10,
                  bold: true,
                },
                {
                  text: "",
                  border: [false, false, false, false],
                  bold: true,
                  alignment: "left",
                },
              ],
              [
                { text: "", colSpan: 3 },
                { text: "" },
                { text: "" },
                { text: "", border: [false, false, false, false] },
                { text: "\n", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
              [
                {
                  text: "",
                  colSpan: 3,
                  border: [false, false, false, false],
                },
                { text: "" },
                { text: "" },
                {
                  text: "GRAND TOTAL",
                  border: [false, false, true, false],
                  alignment: "right",
                },
                {
                  text: (this.sumtotal_KG_Out + this.totalCargo_KG).toFixed(0),
                  color: "#EC37E9",
                  fontSize: 10,
                  bold: true,
                },
                {
                  text: this.sumTotalBaggage_Out + this.totalCargo_amount,
                  color: "#FF2D00",
                  fontSize: 10,
                  bold: true,
                },
                {
                  text: "",
                  border: [false, false, false, false],
                  bold: true,
                  alignment: "left",
                },
              ],
              [
                { text: "", colSpan: 3 },
                { text: "" },
                { text: "" },
                { text: "", border: [false, false, false, false] },
                { text: "\n", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
              [
                {
                  text: "",
                  colSpan: 3,
                  border: [false, false, false, false],
                },
                { text: "" },
                { text: "" },
                {
                  text: "AVAILABLE PAYLOAD",
                  border: [false, false, true, false],
                  alignment: "right",
                },
                {
                  text: this.available_payload,
                  color: "#EC37E9",
                  fontSize: 10,
                  bold: true,
                  colSpan: 2,
                },
                { text: "", border: [false, false, false, false],},
                { text: "Kg.", alignment: "left", border: [false, false, false, false] },
              ],
              [
                {
                  text: "",
                  colSpan: 3,
                  border: [false, false, false, false],
                },
                { text: "" },
                { text: "" },
                {
                  text: "",
                  border: [false, false, false, false],
                  alignment: "right",
                },
                {
                  text: "",
                  color: "#EC37E9",
                  border: [false, false, false, false],
                  fontSize: 10,
                },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
        };
        //End Cargo Manifest PPT & MUBA
      }
      //End Check Customer

      //NIL Passenger & Cargo
      if (this.ArrListPassenger_Manifest.length == 0) {
        NILPassenger = {
          image: NILPassengerImage.image,
          // fit: [NILPassengerImage.w * 0.234, NILPassengerImage.h * 0.234],
          fit: [NILPassengerImage.w * 0.22, NILPassengerImage.h * 0.22],
          absolutePosition: { x: 65, y: 289 },
        };
      }
      if (this.listAddCargo.length == 0) {
        NILCargo = {
          image: NILCargoImage.image,
          // fit: [NILCargoImage.w * 0.11, NILCargoImage.h * 0.11],
          fit: [NILCargoImage.w * 0.157, NILCargoImage.h * 0.157],
          //absolutePosition: { x: 133, y: 524 },
          absolutePosition: { x: 133, y: 494 },
        };
      }

      var tableHead = null;

      if (this.customer.o_name == "UOA") {
        tableHead = {
          headerRows: 1,
          widths: ["*", "auto", "*"],
          body: [
            [
              {
                width: uoaimage.w,
                height: uoaimage.h,
                alignment: "left",
                margin: [15, 0, 0, 0],
                image: uoaimage.logo,
              },
              {
                text: "UNITED OFFSHORE AVIATION",
                style: "tableHeader",
                margin: [0, 15, 0, 0],
              },
              {
                text: "",
              },
            ],
            ["", "", ""],
          ],
        };
      } else {
        tableHead = {
          headerRows: 1,
          widths: ["*", "auto", "*"],
          body: [
            [
              {
                width: uoaimage.w,
                height: uoaimage.h,
                alignment: "left",
                margin: [15, 0, 0, 0],
                image: uoaimage.logo,
              },
              {
                text: "UNITED OFFSHORE AVIATION",
                style: "tableHeader",
                margin: [0, 15, 0, 0],
              },
              {
                width: customerlogo.w,
                height: customerlogo.h,
                alignment: "right",
                margin: [15, 0, 0, 0],
                image: customerlogo.logo,
              },
            ],
            ["", "", ""],
          ],
        };
      }

      var docDefinition = {
        pageMargins: [40, 10, 40, 10],
        content: [
          {
            style: "tableExample",
            table: tableHead,
            layout: "headerLineOnly",
          },
          // { text: "FLIGHT MANIFEST", style: "header" },
          {
            columns: [
              {
                text: "",
              },
              {
                text: "FLIGHT MANIFEST",
                style: "header",
              },
              {
                text: this.reviseNo,
                fontSize: 8,
                alignment: "right",
              },
            ],
          },
          {
            columns: [
              {
                text: "FLIGHT ROUTE",
                fontSize: 8,
                decoration: "underline",
              },
              {
                text: "FLIGHT INFORMATION",
                fontSize: 8,
                decoration: "underline",
              },
            ],
          },
          {
            columns: [
              {
                style: "tableRoute",
                table: flightRoute,
              },
              {
                style: "tableInformation",
                table: flightInformation,
              },
            ],
          },
          {
            columns: [
              { width: "*", text: "" },
              {
                width: "auto",
                table: {
                  body: [listLegs],
                  alignment: "center",
                },
                layout: "noBorders",
              },
              { width: "*", text: "" },
            ],
          },

          { text: "PASSENGER MANIFEST", fontSize: 8, decoration: "underline" },
          passengerManifest,
          NILPassenger,
          {
            text: "Customer Belonging Manifest",
            fontSize: 8,
            decoration: "underline",
          },
          cargoManifest,
          NILCargo,
          "\n",
          {
            table: {
              widths: [30, 250, 40, 110, 10],
              body: [
                [
                  { text: "", border: [false, false, false, false] },
                  {
                    text: this.userdata.FullName,
                    fontSize: 7,
                    border: [false, false, false, false],
                  },
                  {
                    text: "Captain",
                    fontSize: 7,
                    border: [false, false, false, false],
                  },
                  { text: "", border: [false, false, false, true] },
                  { text: "", border: [false, false, false, false] },
                ],

                [
                  { text: "", border: [false, false, false, false] },
                  {
                    text: "Prepared By",
                    fontSize: 7,
                    border: [false, false, false, false],
                  },
                  {
                    text: "Dispatcher",
                    fontSize: 7,
                    border: [false, false, false, false],
                    margin: [0, 5, 0, 0],
                  },
                  { text: "", border: [false, false, false, true] },
                  { text: "", border: [false, false, false, false] },
                ],

                [
                  { text: "", border: [false, false, false, false] },
                  { text: "", border: [false, false, false, false] },
                  { text: "", border: [false, false, false, false] },
                  {
                    text: documentNo,
                    fontSize: 7,
                    border: [false, false, false, false],
                    margin: [0, 5, 0, 0],
                  },
                  { text: "", border: [false, false, false, false] },
                ],
              ],
            },
          },
        ],
        styles: {
          header: {
            fontSize: 13,
            bold: true,
            alignment: "center",
            decoration: "underline",
            margin: [0, 0, 0, 10],
          },
          tableHeader: {
            bold: true,
            fontSize: 14,
            alignment: "center",
            color: "black",
          },
          tableRoute: {
            fontSize: 8,
            margin: [0, 5, 0, 0],
          },
          tableInformation: {
            fontSize: 8,
            margin: [0, 5, 0, 0],
          },
          tableOutBound: {
            fontSize: 6,
            alignment: "center",
            margin: [0, 5, 0, 0],
          },
          tableOutCargo: {
            fontSize: 6,
            alignment: "center",
            margin: [0, 5, 0, 5],
          },
          boderrightleft: {
            border: [true, false, true, false],
          },
          bodertoprightleft: {
            border: [true, true, true, false],
          },
          boderbottonrightleft: {
            border: [true, false, true, true],
          },
          left: {
            fontSize: 8,
            margin: [0, 0, 0, 10],
          },
          tableTotalPax: {
            fontSize: 12,
            alignment: "center",
          },
          tableExample: {
            fontSize: 10,
            alignment: "center",
            margin: [0, 5, 0, 15],
          },
          tableExample1: {
            fontSize: 8,
            alignment: "center",
            margin: [0, 5, 0, 15],
          },
          Borders: {
            border: [false, true, false, true],
          },
        },
        defaultStyle: {},
      };

      pdfMake.createPdf(docDefinition).download("Manifest_Report.pdf");
    },
    // TEST_Report() {
    //   var pdfMake = require("../../public/js/pdfmake");
    //   if (pdfMake.vfs == undefined) {
    //     var pdfFonts = require("../../public/js/vfs_fonts");
    //     pdfMake.vfs = pdfFonts.pdfMake.vfs;
    //   }

    //   for (let index = 0; index < array.length; index++) {
    //     const element = array[index];
    //   }

    //   var docDefinition = {
    //     pageOrientation: "landscape",
    //     content: [
    //       {
    //         // image: './public/favicon.png',
    //         // width: 150,
    //         // height: 150,
    //       },
    //       {
    //         text: "The Report Of BAC and Body Temperature Checks",
    //         style: "header",
    //       },
    //       { text: "Flight no : TESTAUN", style: "right" },
    //       { text: "Date : 03/05/20", style: "right" },
    //       "Outbound Passengers from SKL",
    //       {
    //         style: "tableExample",
    //         table: {
    //           body: [
    //             [
    //               { text: "No.", fillColor: "#64B5F6" },
    //               { text: "Passenger Name", fillColor: "#64B5F6" },
    //               { text: "Company", fillColor: "#64B5F6" },
    //               { text: "Destination", fillColor: "#64B5F6" },
    //               { text: "Temp", fillColor: "#64B5F6" },
    //               { text: "Result#1(mg%BAC)", fillColor: "#FFF59D" },
    //               { text: "Time", fillColor: "#64B5F6" },
    //               { text: "Result#2(mg%BAC)", fillColor: "#FFF59D" },
    //               { text: "Time", fillColor: "#64B5F6" },
    //               { text: "Result#3(mg%BAC)", fillColor: "#FFF59D" },
    //               { text: "Time", fillColor: "#64B5F6" },
    //               { text: "Remark", fillColor: "#64B5F6" },
    //             ],
    //             [
    //               "1",
    //               "ADISAK BAIRAMAN",
    //               "BAYONG",
    //               "DD4",
    //               "36.00",
    //               "0.30",
    //               "17:43",
    //               "0.01",
    //               "17:44",
    //               "0.01",
    //               "17:50",
    //               "-",
    //             ],
    //             [
    //               "2",
    //               "ANUTHEP SENACHAISIT",
    //               "CPOC",
    //               "AQD",
    //               "36.00",
    //               "0.01",
    //               "17:43",
    //               "",
    //               "",
    //               "",
    //               "",
    //               "",
    //             ],
    //             [
    //               "3",
    //               "ANUTHEP SENACHAISIT",
    //               "CPOC",
    //               "AQD",
    //               "36.00",
    //               "0.01",
    //               "17:43",
    //               "",
    //               "",
    //               "",
    //               "",
    //               "",
    //             ],
    //             [
    //               "4",
    //               "ANUTHEP SENACHAISIT",
    //               "CPOC",
    //               "AQD",
    //               "36.00",
    //               "0.01",
    //               "17:43",
    //               "",
    //               "",
    //               "",
    //               "",
    //               "",
    //             ],
    //             [
    //               "5",
    //               "ANUTHEP SENACHAISIT",
    //               "CPOC",
    //               "AQD",
    //               "36.00",
    //               "0.01",
    //               "17:43",
    //               "",
    //               "",
    //               "",
    //               "",
    //               "",
    //             ],
    //             [
    //               "6",
    //               "ANUTHEP SENACHAISIT",
    //               "CPOC",
    //               "AQD",
    //               "36.00",
    //               "0.01",
    //               "17:43",
    //               "",
    //               "",
    //               "",
    //               "",
    //               "",
    //             ],
    //             [
    //               "7",
    //               "ANUTHEP SENACHAISIT",
    //               "CPOC",
    //               "AQD",
    //               "36.00",
    //               "0.01",
    //               "17:43",
    //               "",
    //               "",
    //               "",
    //               "",
    //               "",
    //             ],
    //             [
    //               "8",
    //               "ANUTHEP SENACHAISIT",
    //               "CPOC",
    //               "AQD",
    //               "36.00",
    //               "0.01",
    //               "17:43",
    //               "",
    //               "",
    //               "",
    //               "",
    //               "",
    //             ],
    //             [
    //               "9",
    //               "ANUTHEP SENACHAISIT",
    //               "CPOC",
    //               "AQD",
    //               "36.00",
    //               "0.01",
    //               "17:43",
    //               "",
    //               "",
    //               "",
    //               "",
    //               "",
    //             ],
    //             [
    //               "10",
    //               "ANUTHEP SENACHAISIT",
    //               "CPOC",
    //               "AQD",
    //               "36.00",
    //               "0.01",
    //               "17:43",
    //               "",
    //               "",
    //               "",
    //               "",
    //               "",
    //             ],
    //             [
    //               "11",
    //               "ANUTHEP SENACHAISIT",
    //               "CPOC",
    //               "AQD",
    //               "36.00",
    //               "0.01",
    //               "17:43",
    //               "",
    //               "",
    //               "",
    //               "",
    //               "",
    //             ],
    //             [
    //               "12",
    //               "ANUTHEP SENACHAISIT",
    //               "CPOC",
    //               "AQD",
    //               "36.00",
    //               "0.01",
    //               "17:43",
    //               "",
    //               "",
    //               "",
    //               "",
    //               "",
    //             ],
    //           ],
    //         },
    //       },
    //       {
    //         text: "*All service company BAC test cut off 0.02% or 0 mg/dl (3 time every 15 min.)",
    //         style: "left",
    //       },
    //       { text: "Report by THANONGSAK CHAILAP", style: "right" },
    //       { text: "OPS-FM-91 Issue 01 Revision 01", style: "right" },
    //     ],
    //     styles: {
    //       header: {
    //         fontSize: 16,
    //         bold: true,
    //         alignment: "center",
    //         margin: [0, 0, 0, 10],
    //       },
    //       right: {
    //         alignment: "right",
    //         margin: [0, 0, 0, 10],
    //       },
    //       left: {
    //         fontSize: 8,
    //         margin: [0, 0, 0, 10],
    //       },
    //       tableExample: {
    //         fontSize: 10,
    //         alignment: "center",
    //         margin: [0, 5, 0, 15],
    //       },
    //     },
    //     defaultStyle: {
    //       // alignment: 'justify'
    //     },
    //   };

    //   pdfMake.createPdf(docDefinition).download("BAC_Report.pdf");
    // },

    ReviseAircraftAndDepartureTime() {
      let dateNow = addHours(new Date(), 7).toISOString();
      this.depart_date_revise = dateNow.substring(0, 10);
      this.depart_time_revise = dateNow.substring(11, 16);
      this.dialogReviseAircraftAndDepartTime = true;
    },
    SaveReviseAircraftAndDepartureTime() {},

    GoToFlight() {},
  },
};
</script>

<style>
</style>